var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakingNotesAnimate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-taking-notes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-taking-notes:not(.animated) .animable {opacity: 0;}svg#freepik_stories-taking-notes.animated #freepik--background-complete--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-taking-notes.animated #freepik--Shadows--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0.5s;opacity: 0}svg#freepik_stories-taking-notes.animated #freepik--Board--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-taking-notes.animated #freepik--character-2--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight,1.5s Infinite  linear heartbeat;animation-delay: 0.3s,1.3s;opacity: 0}svg#freepik_stories-taking-notes.animated #freepik--Desk--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-taking-notes.animated #freepik--Device--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-taking-notes.animated #freepik--character-1--inject-77 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,1.5s Infinite  linear floating;animation-delay: 0.3s,1.3s;opacity: 0}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-77",
    className: "animable",
    style: {
      transformOrigin: "254.073px 240.725px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.79,
    y: 91.68,
    width: 48.08,
    height: 56.97,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "407.83px 120.165px"
    },
    id: "eliqzufezq5gp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.56,95.55a1.73,1.73,0,1,1-1.73-1.73A1.72,1.72,0,0,1,409.56,95.55Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "407.83px 95.55px"
    },
    id: "el4gexau2sdv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,103.09c4.86-.38,9.73-.4,14.59-.45s9.72.07,14.58.45c-4.86.37-9.72.4-14.58.45S397.8,103.46,392.94,103.09Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "407.525px 103.09px"
    },
    id: "elb4h0ckfxljf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,107.59a64,64,0,0,1,7.93-.45,60.25,60.25,0,0,1,7.93.45,62,62,0,0,1-7.93.45A64,64,0,0,1,392.94,107.59Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "400.87px 107.59px"
    },
    id: "elljq2ut86f1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,112.09c3.38-.35,6.76-.43,10.13-.45s6.76.1,10.13.45a98,98,0,0,1-10.13.45A101.1,101.1,0,0,1,392.94,112.09Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "403.07px 112.09px"
    },
    id: "el0xnijyyfwbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,116.59c4.23-.35,8.45-.43,12.68-.45s8.45.1,12.67.45c-4.22.36-8.45.44-12.67.46S397.17,117,392.94,116.59Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "405.615px 116.595px"
    },
    id: "elr083eiq4iv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,121.1c3.67-.36,7.34-.44,11-.46s7.35.1,11,.46c-3.67.35-7.35.43-11,.45S396.61,121.45,392.94,121.1Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "403.94px 121.095px"
    },
    id: "elsp1hfmgqfba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,125.6c4.7-.37,9.4-.4,14.1-.45s9.39.07,14.09.45c-4.7.38-9.39.4-14.09.45S397.64,126,392.94,125.6Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "407.035px 125.601px"
    },
    id: "el0ljzwxi5fj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,130.1a92.34,92.34,0,0,1,18.21,0,79.33,79.33,0,0,1-9.1.45A81.73,81.73,0,0,1,392.94,130.1Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "402.045px 130.101px"
    },
    id: "elqoorcty6xf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,134.6c4.86-.37,9.73-.39,14.59-.45s9.72.08,14.58.45c-4.86.38-9.72.4-14.58.46S397.8,135,392.94,134.6Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "407.525px 134.606px"
    },
    id: "elh9c2kqhzo1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,139.11c4.86-.38,9.73-.4,14.59-.46s9.72.08,14.58.46c-4.86.37-9.72.4-14.58.45S397.8,139.48,392.94,139.11Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "407.525px 139.103px"
    },
    id: "el1v2isnxea1g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.89,
    y: 155.14,
    width: 56.89,
    height: 67.41,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "82.335px 188.845px"
    },
    id: "elymgda2aadep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.34,
    cy: 164.24,
    r: 1.73,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "82.34px 164.24px"
    },
    id: "elvtvkzble3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,172a44.4,44.4,0,0,1,12.61,0,38.2,38.2,0,0,1-6.31.45A39.27,39.27,0,0,1,61.86,172Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "68.165px 172.001px"
    },
    id: "ele6f9zmvtbfu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,177a67.63,67.63,0,0,1,8.16-.45,67.68,67.68,0,0,1,8.17.45,65.71,65.71,0,0,1-8.17.46A65.65,65.65,0,0,1,61.86,177Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "70.025px 177.005px"
    },
    id: "elooqawxo7g5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,182.13a56.39,56.39,0,0,1,7.56-.45,54.84,54.84,0,0,1,7.57.45,63.81,63.81,0,0,1-15.13,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "69.425px 182.129px"
    },
    id: "el9ewt3qnaeyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,187.21a58.1,58.1,0,0,1,7.56-.45,56.44,56.44,0,0,1,7.57.45,54.84,54.84,0,0,1-7.57.45A58.1,58.1,0,0,1,61.86,187.21Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "69.425px 187.21px"
    },
    id: "elqtktvnbyu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,192.29a48.19,48.19,0,0,1,13.14,0,47.15,47.15,0,0,1-13.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "68.43px 192.295px"
    },
    id: "elvz7osak6a5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,197.38a69.72,69.72,0,0,1,8.41-.46,69.88,69.88,0,0,1,8.42.46,72,72,0,0,1-8.42.45A71.81,71.81,0,0,1,61.86,197.38Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "70.275px 197.375px"
    },
    id: "elobvf9yapho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,202.46A49,49,0,0,1,68.8,202a46.36,46.36,0,0,1,7,.45,47.72,47.72,0,0,1-7,.45A49,49,0,0,1,61.86,202.46Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "68.83px 202.45px"
    },
    id: "el57uwhcl2jqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,207.54a76.82,76.82,0,0,1,8.7-.45,77,77,0,0,1,8.71.45,72.61,72.61,0,0,1-8.71.45A74.57,74.57,0,0,1,61.86,207.54Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "70.565px 207.541px"
    },
    id: "el6lv20r81g1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.86,212.63a74.58,74.58,0,0,1,8.7-.46,74.75,74.75,0,0,1,8.71.46,77,77,0,0,1-8.71.45A76.82,76.82,0,0,1,61.86,212.63Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "70.565px 212.625px"
    },
    id: "el2n96989z596",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,172a76.13,76.13,0,0,1,16.53,0,65.49,65.49,0,0,1-8.27.45A67.25,67.25,0,0,1,86.72,172Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "94.985px 172.001px"
    },
    id: "elbq4fx01p8pk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,177a33,33,0,0,1,10.87,0,32.34,32.34,0,0,1-10.87,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "92.155px 177.005px"
    },
    id: "elz4xy5aryk2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,182.13a59.55,59.55,0,0,1,7.77-.45,57.91,57.91,0,0,1,7.78.45,67.39,67.39,0,0,1-15.55,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "94.495px 182.129px"
    },
    id: "elb2oj54nm6bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,187.21a58.1,58.1,0,0,1,7.56-.45,56.44,56.44,0,0,1,7.57.45,54.84,54.84,0,0,1-7.57.45A58.1,58.1,0,0,1,86.72,187.21Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "94.285px 187.21px"
    },
    id: "el3pjq59p2nkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,192.29a76.13,76.13,0,0,1,16.53,0,74.48,74.48,0,0,1-16.53,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "94.985px 192.295px"
    },
    id: "elupi99gpxph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,197.38a47.15,47.15,0,0,1,13.14,0,48.19,48.19,0,0,1-13.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "93.29px 197.375px"
    },
    id: "el4lzoequ58ta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,202.46a61.35,61.35,0,0,1,7.77-.45,57.91,57.91,0,0,1,7.78.45,59.6,59.6,0,0,1-7.78.45A61.35,61.35,0,0,1,86.72,202.46Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "94.495px 202.46px"
    },
    id: "elzrpiomx09se",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,207.54a40.43,40.43,0,0,1,12,0,34.87,34.87,0,0,1-6,.45A35.77,35.77,0,0,1,86.72,207.54Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "92.72px 207.542px"
    },
    id: "ely03eqbd1e5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,212.63a36.42,36.42,0,0,1,11.54,0,37.22,37.22,0,0,1-11.54,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "92.49px 212.625px"
    },
    id: "el48nud4lue5x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.32,
    y: 213.95,
    width: 28.93,
    height: 28.93,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "110.785px 228.415px"
    },
    id: "el30tg23814ug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,216.89a1.73,1.73,0,1,1-1.72-1.73A1.73,1.73,0,0,1,112.51,216.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "110.78px 216.89px"
    },
    id: "el501uf1kz4w9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.82,282.6a43.74,43.74,0,0,1-2.14,16.69,47.08,47.08,0,0,1-3.14,7.21c-1.57,3-3.19,5.85-3.12,9.23.31.24-.8.12-.81-.21-8.57-5.8-20-7.62-26.25-16.5-3-4.2-4.22-9.33-4.62-14.4-.43-5.52-.2-11.58,1.63-16.85,1.53-4.45,4.53-8.64,9-10.53,4.59-2,10.35-1.32,14.88.48C400,261.6,404.15,272.8,404.82,282.6Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "384.735px 285.939px"
    },
    id: "el3dt334faov6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.3,349.31c-.91-4.17-1.81-8.34-2.76-12.51-1.84-8.16-3.79-16.29-6-24.35q-2-7.24-4.29-14.38a82.53,82.53,0,0,1,1.74-8.58c1-3.42,2.36-6.69,3.64-10,.08-.21-.25-.34-.35-.15-2.38,4.53-5.47,10.32-6,15.87-1.79-5.39-3.73-10.71-5.86-16a66.09,66.09,0,0,1,1.39-12.81.16.16,0,0,0-.3-.08,45.76,45.76,0,0,0-1.75,11.27c-1.63-4-3.37-7.87-5.25-11.74-.17-.35-.65,0-.51.3,2.87,6.75,5.48,13.61,7.9,20.55a43.34,43.34,0,0,0-13.43-9.23c-.22-.09-.41.22-.19.33a51.37,51.37,0,0,1,14.43,11.24q2.58,7.6,4.88,15.32c-5.19-5.93-12.59-10.14-19.86-12.65-.25-.09-.35.29-.11.39,8.39,3.24,14.69,8.63,20.78,15q.9,3.11,1.76,6.24,3.27,11.83,6.12,23.79,1.38,5.73,2.7,11.46c.94,4.12,1.6,8.44,2.93,12.45.13.38.8.35.75-.1A116,116,0,0,0,404.3,349.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "389.073px 313.503px"
    },
    id: "el3adc9dyud02",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.16,274a22.24,22.24,0,0,0-3.85,7.8c0,.07.09.12.12.05a70.88,70.88,0,0,1,4.11-7.63C395.7,273.93,395.33,273.74,395.16,274Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "393.445px 277.88px"
    },
    id: "eliqrwn978x7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,291.4a23.52,23.52,0,0,0-7.83-3.33c-.07,0-.13.09-.05.13,1.25.63,2.58,1.11,3.85,1.72s2.51,1.32,3.8,1.88A.23.23,0,0,0,377.72,291.4Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "373.819px 289.95px"
    },
    id: "elcvybbwzn2yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,268.59a15.2,15.2,0,0,0-2.46-1.8c-.14-.07-.28.1-.17.21a16.2,16.2,0,0,0,2.42,1.86C374.9,269,375.11,268.71,375,268.59Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "373.681px 267.835px"
    },
    id: "elas1fbmca5d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.52,299.93c-6.54,1.67-13.11,3.19-19.66,4.84-.57.14-10.69-21.24-6.31-31.89,4-9.85,12.7-17,22.81-20,4.68-1.39,10.41-2.48,15.25-1.22,4.3,1.13,7.23,4.8,8.48,8.94,1.7,5.62.8,12.21-.46,17.84a31.19,31.19,0,0,1-6.94,14.3C442.1,296.68,437.63,298.63,432.52,299.93Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "429.74px 277.938px"
    },
    id: "el4jmy1bg9qn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.68,280.38a86.92,86.92,0,0,1-12.88,4.5,52.85,52.85,0,0,0-8.59,2.73c3-6,6.2-11.83,9.62-17.62,4.23-1,8.7-2.76,12-5.59a.18.18,0,0,0-.22-.29c-3.54,2.31-7.4,3.62-11.28,5.12q1.38-2.34,2.8-4.66c.26-.43-.33-.9-.64-.48a137.16,137.16,0,0,0-9.8,15.08,70.61,70.61,0,0,1-.11-14.17.1.1,0,0,0-.19,0,47.2,47.2,0,0,0-.45,15.55c-2.44,4.44-4.69,9-6.73,13.62-.63-2.85-1.48-5.66-2-8.53a38.85,38.85,0,0,1-.44-12.5c0-.12-.17-.13-.19,0a44,44,0,0,0,1.82,23c-1.19,2.79-2.33,5.59-3.39,8.4A169.84,169.84,0,0,0,401.62,349a.28.28,0,0,0,.55.07,222.4,222.4,0,0,1,11.37-44c2.1-5.57,4.47-11,7-16.25,3.87-1,7.73-2.36,11.54-3.51a35.87,35.87,0,0,0,10.69-4.74A.13.13,0,0,0,442.68,280.38Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "422.261px 306.601px"
    },
    id: "elzgqcy5onem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,274.52c-4,1.26-7.84,3.08-11.84,4.35-.19.06-.1.36.09.33,4.22-.7,8.42-1.83,11.9-4.44C449.23,274.66,449.09,274.48,449,274.52Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "443.114px 276.858px"
    },
    id: "elbrxddmjz3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,264.72c0-.2-.25-.34-.32-.12-1.23,3.6-2.13,7.44-1.22,11.21a.14.14,0,0,0,.28,0C416.06,272.06,416,268.39,417,264.72Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "416.044px 270.219px"
    },
    id: "elht21m46v5k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.66,256.94a9.57,9.57,0,0,0-2,6.13c0,.14.22.23.26.07.56-2.07,1.44-3.94,2.16-5.94A.27.27,0,0,0,433.66,256.94Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "432.869px 260.059px"
    },
    id: "elxttgg8s7r9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.13,314.85c-1.9,6-6.41,14.36-13.55,14.42-4.63.05-9.29-.5-13.94-.57-5-.07-9.95-.06-14.91.23-.41,0,.6-14.88,12.54-22.14,3.35-2,7.44-2.68,11.24-3.5a52.11,52.11,0,0,1,13.28-1.39c2.74.11,5,.7,6,3.51S454,312,453.13,314.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "432.458px 315.579px"
    },
    id: "elj4wq84ms45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,307.31c-2.9.75-5.83,1.61-8.74,2.53a33.31,33.31,0,0,1,2.4-2.35c1.26-1,2.63-1.87,4-2.78.12-.07.05-.29-.09-.23a16.35,16.35,0,0,0-7,5.6c-3.63,1.17-7.23,2.47-10.69,3.89a40.83,40.83,0,0,0-6.85,3.6,28.82,28.82,0,0,1,2.48-4.31c1.59-2.05,3.73-3.2,5.81-4.65a.19.19,0,0,0-.19-.32,17,17,0,0,0-9.32,10.1,40,40,0,0,0-6.77,6.15c-7.91,9-14.13,20.93-14.16,33.12,0,.29.47.37.53.07a67.52,67.52,0,0,1,15.07-32.38c.57-.66,1.15-1.29,1.74-1.9a52.69,52.69,0,0,1,6.53-.48c2.54,0,5.07.37,7.6.58,4.17.34,8.78.39,12.54-1.71a.18.18,0,0,0-.13-.32c-8.39,3.05-17.18-.81-25.59,1a39.2,39.2,0,0,1,12.4-8l.77-.31c5.38.65,11.07,2,16.31.3a.13.13,0,0,0-.07-.25c-5.07,1.27-9.92-.32-14.92-.58,5.44-2.12,11-3.8,16.45-5.91C448.48,307.61,448.49,307.19,448,307.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "423.629px 331.195px"
    },
    id: "ellr4n3jnc1ts",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.37,312.61a71.14,71.14,0,0,1-7.84.6.06.06,0,0,0,0,.11,16.18,16.18,0,0,0,7.9-.51A.1.1,0,0,0,450.37,312.61Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "446.499px 313.098px"
    },
    id: "el8xecflb4r5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.67,307.45a12.76,12.76,0,0,0-3.88,2.69c-.13.12,0,.37.2.26.66-.48,1.34-.93,2-1.37a19.47,19.47,0,0,0,1.89-1.2C433.08,307.69,432.89,307.37,432.67,307.45Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "430.851px 308.932px"
    },
    id: "elw4jh001eh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,326.84c.08.2-.2.39-.31.18h0a.31.31,0,0,1-.19.12,121,121,0,0,1-14.59,2.55c-3.95.35-8.51.57-12-1.73-4.68-3.1-7.76-11.41-5.23-16.69,3-6.26,12-2.86,16.56-.63A33.24,33.24,0,0,1,390.49,326.84Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "373.883px 318.8px"
    },
    id: "elji35bp3k21n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,329.74a47,47,0,0,0-8.71-6.63,29.91,29.91,0,0,0-8.84-9c-.17-.12-.32.15-.16.27a40,40,0,0,1,7.44,7.84,81.71,81.71,0,0,0-10.93-5,14.58,14.58,0,0,0-5.87-5.88c-.05,0-.11,0-.06.08a23.92,23.92,0,0,1,5.3,5.57c-2.22-.83-4.47-1.6-6.71-2.35-.2-.06-.28.24-.08.32,4,1.56,8.07,3.2,12,5.1a46.48,46.48,0,0,1-14.56,0,.1.1,0,1,0-.06.2,28.69,28.69,0,0,0,15.46.23,73.94,73.94,0,0,1,7.33,4.11,18.38,18.38,0,0,0-5.93.48,45.11,45.11,0,0,1-10.41,1.18c-.13,0-.17.22,0,.24,6,1,11.75-1.71,17.74-1a46,46,0,0,1,6.23,5.09,46.92,46.92,0,0,1,9.1,12.83c2.52,5.13,3.88,10.57,5.92,15.87a.19.19,0,0,0,.37-.11C406.81,348.71,401.6,337.19,394,329.74Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "385.631px 335.383px"
    },
    id: "el7tt5edbfs2u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,315.41a7.14,7.14,0,0,0-1.54-1.88,6.28,6.28,0,0,0-1.79-1.33c-.06,0-.09.06-.06.1.5.56,1.19,1,1.72,1.51s1,1.18,1.53,1.71A.09.09,0,0,0,375.77,315.41Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "374.075px 313.872px"
    },
    id: "el948rsum43nc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.81,318.65c-.9-.22-1.84-.2-2.75-.39a26.53,26.53,0,0,1-2.67-.8c-.12,0-.19.13-.09.2a8.93,8.93,0,0,0,5.51,1.28C366,318.91,365.94,318.69,365.81,318.65Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "363.092px 318.22px"
    },
    id: "elsmv4e3bw33n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.72 340.81 421.73 352 418.39 389.77 388.81 389.77 384.63 352 383.4 340.81 422.72 340.81",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "403.06px 365.29px"
    },
    id: "elhm3oh6xtz8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.72 340.81 421.73 352 384.63 352 383.4 340.81 422.72 340.81",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "403.06px 346.405px"
    },
    id: "elrtz5woho13",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.47,
    y: 337.76,
    width: 45.18,
    height: 9.08,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "403.06px 342.3px"
    },
    id: "elysok5615r6",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-77",
    className: "animable",
    style: {
      transformOrigin: "250px 389.77px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "43.31 389.77 94.98 389.52 146.66 389.44 250 389.27 353.34 389.43 405.02 389.52 456.69 389.77 405.02 390.01 353.34 390.1 250 390.27 146.66 390.1 94.98 390.01 43.31 389.77",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 389.77px"
    },
    id: "elrdq4un8slip",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-77",
    className: "animable",
    style: {
      transformOrigin: "250.32px 429.89px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 380.06,
    cy: 411.29,
    rx: 77.89,
    ry: 12.38,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "380.06px 411.29px"
    },
    id: "eli73l4a0s2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.4,
    cy: 436.29,
    rx: 177.71,
    ry: 24.58,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "220.4px 436.29px"
    },
    id: "elyyepzxwv4w",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-77",
    className: "animable",
    style: {
      transformOrigin: "249.995px 150.7px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.2,
    y: 76.07,
    width: 237.47,
    height: 156.95,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "249.935px 154.545px"
    },
    id: "elimkvsy0co3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.54,
    y: 68.38,
    width: 248.91,
    height: 7.69,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "249.995px 72.225px"
    },
    id: "elcuo7j5y41il",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 102.92,
    width: 37.49,
    height: 44.43,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "166.245px 125.135px"
    },
    id: "elbd0i6h10jyv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.59,105.94a1.35,1.35,0,1,1-1.35-1.35A1.35,1.35,0,0,1,167.59,105.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "166.24px 105.94px"
    },
    id: "elchn7iuncjda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,111.82c3.79-.29,7.58-.31,11.37-.35s7.59,0,11.38.35c-3.79.29-7.58.31-11.38.35S158.42,112.11,154.63,111.82Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "166.005px 111.818px"
    },
    id: "eleybsyrwzea8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,115.33a54.82,54.82,0,0,1,12.37,0,47.58,47.58,0,0,1-6.19.35A49.25,49.25,0,0,1,154.63,115.33Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "160.815px 115.331px"
    },
    id: "eloguvwdykc2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,118.84a89.33,89.33,0,0,1,15.8,0,77.33,77.33,0,0,1-7.9.35C159.9,119.18,157.26,119.11,154.63,118.84Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "162.53px 118.841px"
    },
    id: "elxrlvqcnxsv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,122.35c3.3-.27,6.59-.34,9.89-.35s6.59.07,9.88.35c-3.29.28-6.59.34-9.88.35S157.93,122.63,154.63,122.35Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "164.515px 122.35px"
    },
    id: "elsenm5whdmdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,125.86c2.86-.27,5.73-.34,8.59-.35s5.72.08,8.59.35c-2.87.28-5.73.34-8.59.35S157.49,126.14,154.63,125.86Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "163.22px 125.86px"
    },
    id: "elstdbcgbo58g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,129.37c3.67-.29,7.33-.31,11-.35s7.33.06,11,.35c-3.66.3-7.32.31-11,.36S158.3,129.66,154.63,129.37Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "165.63px 129.376px"
    },
    id: "el5vgd4jb24kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,132.88a67.51,67.51,0,0,1,7.1-.35,64.91,64.91,0,0,1,7.1.35,70.19,70.19,0,0,1-14.2,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "161.73px 132.885px"
    },
    id: "elq3tftwh8mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,136.4c3.79-.3,7.58-.32,11.37-.36s7.59.06,11.38.36c-3.79.29-7.58.31-11.38.35S158.42,136.69,154.63,136.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "166.005px 136.395px"
    },
    id: "el5bjawyyioxe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.63,139.91c3.79-.3,7.58-.31,11.37-.36s7.59.06,11.38.36c-3.79.29-7.58.31-11.38.35S158.42,140.2,154.63,139.91Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "166.005px 139.903px"
    },
    id: "elasupylkewlg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.75,
    y: 163.93,
    width: 44.37,
    height: 52.57,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "181.935px 190.215px"
    },
    id: "eludtfehew92c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.28,171a1.35,1.35,0,1,1-1.35-1.35A1.34,1.34,0,0,1,183.28,171Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "181.93px 171px"
    },
    id: "elx6ifcn7cet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,177.05a34.76,34.76,0,0,1,9.84,0,30.16,30.16,0,0,1-4.92.35A31.32,31.32,0,0,1,166,177.05Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "170.92px 177.051px"
    },
    id: "el3768s4knspx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,181a58.14,58.14,0,0,1,12.74,0A56.54,56.54,0,0,1,166,181Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "172.37px 181.005px"
    },
    id: "elm4nerf4nqjq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,185a48.53,48.53,0,0,1,11.8,0,49.9,49.9,0,0,1-11.8,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "171.9px 184.995px"
    },
    id: "elvbgvx4fsm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,188.94a44.91,44.91,0,0,1,5.9-.35,43.25,43.25,0,0,1,5.9.35,49.9,49.9,0,0,1-11.8,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "171.9px 188.939px"
    },
    id: "elv8b2csndhv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,192.9a35.38,35.38,0,0,1,5.13-.35,34,34,0,0,1,5.12.35,36.66,36.66,0,0,1-10.25,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "171.125px 192.905px"
    },
    id: "el9vjiym88ana",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,196.87a61.65,61.65,0,0,1,13.12,0,61.65,61.65,0,0,1-13.12,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "172.56px 196.87px"
    },
    id: "el8pi0zd9shk4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,200.83a42.06,42.06,0,0,1,10.83,0,42.06,42.06,0,0,1-10.83,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "171.415px 200.83px"
    },
    id: "elrr8sder225g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,204.8a64.21,64.21,0,0,1,13.58,0,59.39,59.39,0,0,1-6.79.35A61.76,61.76,0,0,1,166,204.8Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "172.79px 204.795px"
    },
    id: "elwk2wacnxh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,208.76a66,66,0,0,1,13.58,0,57.2,57.2,0,0,1-6.79.35A59.39,59.39,0,0,1,166,208.76Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "172.79px 208.761px"
    },
    id: "els0q19bbzu3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,177.05a59.52,59.52,0,0,1,12.89,0,51.64,51.64,0,0,1-6.45.35A53.34,53.34,0,0,1,185.35,177.05Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "191.795px 177.051px"
    },
    id: "elslfej0brc1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,181a25.8,25.8,0,0,1,8.47,0,25.09,25.09,0,0,1-8.47,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "189.585px 181.005px"
    },
    id: "elm5i5ujxosbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,185a51.27,51.27,0,0,1,12.13,0,52.72,52.72,0,0,1-12.13,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "191.415px 184.995px"
    },
    id: "elb2gugyec3f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,188.94a44.81,44.81,0,0,1,5.9-.35,43.35,43.35,0,0,1,5.9.35,49.9,49.9,0,0,1-11.8,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "191.25px 188.939px"
    },
    id: "el1ux3e33sesej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,192.9a55.47,55.47,0,0,1,6.44-.35,53.62,53.62,0,0,1,6.45.35,57.87,57.87,0,0,1-12.89,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "191.795px 192.905px"
    },
    id: "elmg9pfxpg07j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,196.87a37.7,37.7,0,0,1,10.25,0,37.7,37.7,0,0,1-10.25,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "190.475px 196.87px"
    },
    id: "el8h32adggw24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,200.83a52.72,52.72,0,0,1,12.13,0,52.72,52.72,0,0,1-12.13,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "191.415px 200.83px"
    },
    id: "el4ff3kpi4a1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,204.8a30.73,30.73,0,0,1,9.38,0,28.57,28.57,0,0,1-4.69.35A29.53,29.53,0,0,1,185.35,204.8Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "190.04px 204.795px"
    },
    id: "elaaqvtatv4x9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.35,208.76a29.1,29.1,0,0,1,9,0,25.28,25.28,0,0,1-4.5.35A26.25,26.25,0,0,1,185.35,208.76Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "189.85px 208.761px"
    },
    id: "el8dz5ajyopbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.54,
    y: 90.7,
    width: 22.56,
    height: 22.56,
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "192.82px 101.98px"
    },
    id: "elbk0iiwzb97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.17,93a1.35,1.35,0,1,1-1.35-1.34A1.34,1.34,0,0,1,194.17,93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "192.82px 93.01px"
    },
    id: "el08lluoxk7ilt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.2,
    y: 76.07,
    width: 237.47,
    height: 9.99,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "249.935px 81.065px"
    },
    id: "elpuwsimjay7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 103.18 283.78 103.03 352.58 103.18 283.78 103.33 214.98 103.18",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 103.18px"
    },
    id: "el9l61xja7m3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 108.79 283.78 108.64 352.58 108.79 283.78 108.94 214.98 108.79",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 108.79px"
    },
    id: "el2vi5h51jq7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 114.4 283.78 114.25 352.58 114.4 283.78 114.55 214.98 114.4",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 114.4px"
    },
    id: "elbjp4u84cixl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 120.01 283.78 119.86 352.58 120.01 283.78 120.16 214.98 120.01",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 120.01px"
    },
    id: "els1lm28qabr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 125.62 283.78 125.48 352.58 125.62 283.78 125.77 214.98 125.62",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 125.625px"
    },
    id: "elmlf1u6k31ra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 131.24 283.78 131.09 352.58 131.24 283.78 131.38 214.98 131.24",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 131.235px"
    },
    id: "elmera1z7z31n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 136.85 283.78 136.7 352.58 136.85 283.78 136.99 214.98 136.85",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 136.845px"
    },
    id: "eld9ejpm33zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 142.46 283.78 142.31 352.58 142.46 283.78 142.6 214.98 142.46",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 142.455px"
    },
    id: "elh2jv92o3n07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 148.07 283.78 147.92 352.58 148.07 283.78 148.22 214.98 148.07",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 148.07px"
    },
    id: "elnbyjalr7geq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 153.68 283.78 153.53 352.58 153.68 283.78 153.83 214.98 153.68",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 153.68px"
    },
    id: "elyaun95g51d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 159.29 283.78 159.14 352.58 159.29 283.78 159.44 214.98 159.29",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 159.29px"
    },
    id: "elcp5r1wphvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 164.9 283.78 164.75 352.58 164.9 283.78 165.05 214.98 164.9",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 164.9px"
    },
    id: "elaulepzjqw4p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 170.51 283.78 170.36 352.58 170.51 283.78 170.66 214.98 170.51",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 170.51px"
    },
    id: "elkgivpbpe9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 176.12 283.78 175.97 352.58 176.12 283.78 176.27 214.98 176.12",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 176.12px"
    },
    id: "elwx1tkgyh9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.98 181.73 283.78 181.59 352.58 181.73 283.78 181.88 214.98 181.73",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "283.78px 181.735px"
    },
    id: "elgk1v2gngcau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.53,
    y: 142.46,
    width: 10.43,
    height: 45.82,
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "234.745px 165.37px"
    },
    id: "el2sbgcikdbyy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.88,
    y: 123.08,
    width: 10.43,
    height: 65.2,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "254.095px 155.68px"
    },
    id: "el5jjyqu1spqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.24,
    y: 114.28,
    width: 10.43,
    height: 74,
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "273.455px 151.28px"
    },
    id: "elej0qza0a5p8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.6,
    y: 125.75,
    width: 10.43,
    height: 62.52,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "292.815px 157.01px"
    },
    id: "eljjv20j6d1mg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.96,
    y: 129.17,
    width: 10.43,
    height: 59.11,
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "312.175px 158.725px"
    },
    id: "el91cchwsjeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.31,
    y: 162.66,
    width: 10.43,
    height: 25.62,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "331.525px 175.47px"
    },
    id: "elgloq7c2ih3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.71,99.24l.23,22.26.16,22.26q.17,22.26.16,44.52l-.55-.55,33.47,0,33.46.07,33.47.18,33.47.33-33.47.32-33.47.18-33.46.07-33.47,0h-.55v-.55q0-22.26.16-44.52l.16-22.26Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "285.37px 144.06px"
    },
    id: "elz97xm5tx3vc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.53,
    y: 192.98,
    width: 10.43,
    height: 0.94,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "234.745px 193.45px"
    },
    id: "elf5dvl3ckjv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.88,
    y: 192.98,
    width: 10.43,
    height: 0.94,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "254.095px 193.45px"
    },
    id: "elqdxxzpfav9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.24,
    y: 192.98,
    width: 10.43,
    height: 0.94,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "273.455px 193.45px"
    },
    id: "elcdhk36bj3oc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.6,
    y: 192.98,
    width: 10.43,
    height: 0.94,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "292.815px 193.45px"
    },
    id: "el1w7ja234aa5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.96,
    y: 192.98,
    width: 10.43,
    height: 0.94,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "312.175px 193.45px"
    },
    id: "el3586d83rl5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.31,
    y: 192.98,
    width: 10.43,
    height: 0.94,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "331.525px 193.45px"
    },
    id: "elo2mdpb5y3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.34,
    y: 205.15,
    width: 22.93,
    height: 1.97,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "239.805px 206.135px"
    },
    id: "elri1nh6lxz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.34,
    y: 209.26,
    width: 30.98,
    height: 1.97,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "243.83px 210.245px"
    },
    id: "elhlgkri76fur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.34,
    y: 213.38,
    width: 16.44,
    height: 1.97,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "236.56px 214.365px"
    },
    id: "el54t4v0gyso2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.45,
    y: 205.15,
    width: 4.78,
    height: 4.78,
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "220.84px 207.54px"
    },
    id: "eldi6oil5ed5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.6,
    y: 205.15,
    width: 27.26,
    height: 1.97,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "295.23px 206.135px"
    },
    id: "el0dgvxy1xnjc6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.6,
    y: 209.26,
    width: 21.56,
    height: 1.97,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "292.38px 210.245px"
    },
    id: "elzwe4g73pkxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.6,
    y: 213.38,
    width: 30.98,
    height: 1.97,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "297.09px 214.365px"
    },
    id: "elty2uagprpwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.7,
    y: 205.15,
    width: 4.78,
    height: 4.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "274.09px 207.54px"
    },
    id: "ely6id1gulubo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-77",
    className: "animable",
    style: {
      transformOrigin: "364.411px 270.782px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.7,410c1.8.58,54.36-.22,56.29-1.48.23-.14.26-4.89.2-11.41l2.56-38.68-33.26.1L343.86,392s-7.46,3.44-13.62,6.45h0a74.32,74.32,0,0,0-7.84,4.15C320.43,404.24,318.91,409.4,320.7,410Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "349.827px 384.311px"
    },
    id: "elgoc5le3to9t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.7,410c1.8.58,54.36-.22,56.29-1.48.23-.14.26-4.89.2-11.41-13,2.9-47.61,7.58-48.62,4.86-.4-1.08.42-2.32,1.66-3.47a74.32,74.32,0,0,0-7.84,4.15C320.43,404.24,318.91,409.4,320.7,410Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.56px 403.651px"
    },
    id: "el5uscg54dyhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.79,217.64s-9.4,100-9.63,101.17c0,.16-.1,2-.19,5-.52,16.5-1.81,67.92-1.81,67.92H342.64s2.57-60.91,4.06-75.12c1.88-18.12,13.49-99,13.49-99Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "368.215px 304.67px"
    },
    id: "el54wokxvmof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.45,322.19q1.83-31.14,5.5-62.12c1.38-11.64,3.05-23.24,4.71-34.85,0-.1.18-.09.16,0-3.06,20.65-5.22,41.46-7.09,62.25s-3.17,41.57-4,62.4c-.48,11.8-.84,23.61-1.22,35.42a.22.22,0,0,1-.44,0C377.61,364.25,378.21,343.2,379.45,322.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.446px 305.329px"
    },
    id: "elf03lcyq4jq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.13,385.37c1-.14,2.16-.09,3.21-.13s2.38-.05,3.56-.1q3.44-.12,6.87-.18c4.61-.07,9.24,0,13.85.1l3.8.13c1.36.05,2.71.18,4.06.17.11,0,.1.12,0,.12-2.32,0-4.67.2-7,.29s-4.57.12-6.86.15c-4.61.07-9.24,0-13.85-.15l-3.81-.1-2-.08c-.6,0-1.2,0-1.8-.06A.08.08,0,0,1,345.13,385.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.812px 385.439px"
    },
    id: "elt3m6tx9alws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.25,217.64l18,130.2c.26-9.71.51-18.68.68-24,.09-3,.16-4.85.19-5,.22-1.21,9.63-101.17,9.63-101.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.5px 282.74px"
    },
    id: "el8alfsf9h7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9,416.91c1.88-.16,50.1-21.1,51.4-23,.16-.22-1.64-4.62-4.21-10.6l-10.63-37.48L392.7,358.17l8.68,33.26s-5.57,6-10.09,11.19v0a72.46,72.46,0,0,0-5.64,6.84C384.44,411.72,385,417.07,386.9,416.91Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "411.661px 381.372px"
    },
    id: "el36nd5v2tn7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9,416.91c1.88-.16,50.1-21.1,51.4-23,.16-.22-1.64-4.62-4.21-10.6-10.87,7.66-41,25.3-43,23.17-.79-.84-.5-2.3.2-3.83a72.46,72.46,0,0,0-5.64,6.84C384.44,411.72,385,417.07,386.9,416.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "411.661px 400.112px"
    },
    id: "elf88t193pnow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.56,379.44l-38.56,12s-18.82-66.07-20.27-81.59-2.8-46.79-3.42-69.58c0,0-6.44-3.81-8.07-5.89s-3.1-9.58-6.32-16.73h47.17c11.27,21.89,2.79,31.63,2.79,36.41,0,23.05,3.48,53.64,4.59,58.17C417.78,321.7,437.56,379.44,437.56,379.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "399.24px 304.545px"
    },
    id: "elugtpdxusul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.09,383c1-.4,2.06-.64,3.06-.95s2.29-.66,3.42-1c2.19-.68,4.38-1.33,6.59-2,4.43-1.26,8.91-2.43,13.4-3.48l3.71-.85c1.32-.31,2.66-.54,4-.89.1,0,.12.09,0,.12-2.24.59-4.46,1.4-6.68,2.08s-4.39,1.3-6.59,1.92c-4.44,1.26-8.92,2.42-13.42,3.44-1.24.28-2.47.6-3.7.89l-2,.44c-.59.13-1.16.33-1.76.41A.08.08,0,0,1,399.09,383Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "416.21px 378.48px"
    },
    id: "elth9trsfvc6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.14,233.87a35.8,35.8,0,0,1,6.39,3.78c2.12,1.45,4.06,3.12,6.09,4.67.08.06,0,.19-.08.13-2.14-1.37-4.39-2.57-6.51-4a41.29,41.29,0,0,1-6-4.43A.11.11,0,0,1,366.14,233.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.338px 238.168px"
    },
    id: "elvznrzxfmk3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.85,220.61c.27,1.47.63,2.92.94,4.38s.52,2.77.88,4.12a7,7,0,0,0,1.92,3.46c.54.49,1.13.94,1.7,1.39.31.25.65.49,1,.74,0-.2-.08-.39-.11-.59-.1-.56-.19-1.12-.29-1.67-.21-1.24-.4-2.48-.59-3.72-.38-2.44-.72-4.9-1.23-7.31,0-.1.13-.14.15,0,.61,2.39,1.28,4.76,1.81,7.17.26,1.18,1.19,7,1.23,7.43s.07.85.09,1.28a5.22,5.22,0,0,1,0,1.31c0,.11-.15.09-.2,0h0a5.16,5.16,0,0,1-.38-1.27c-.1-.42-.2-.84-.27-1.27,0-.15-.05-.31-.07-.46-.58-.35-1.11-.81-1.65-1.2s-1.17-.83-1.72-1.29a6.59,6.59,0,0,1-2.09-3.28,23.79,23.79,0,0,1-.69-4.19c-.19-1.66-.32-3.33-.55-5C365.68,220.55,365.83,220.51,365.85,220.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.556px 229.613px"
    },
    id: "el7yorv9hsy14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.77,158.51c-.61,9.26-1.09,18.8-.27,28.05.64,7.21,3.6,13.17,11.07,15,6.92,1.71,16.82,1.69,22.74-2.85,2.76-2.12,3.74-5.14,3.59-8.54-.2-4.72-3.67-30.59-4.7-38.66a83.92,83.92,0,0,0-2.71-14.66c-3.13-10-8.05-10-8.74-10.16-.58-.38-4.34-2.11-9.74-.45a10.5,10.5,0,0,0-6.45,5.62C368.61,139.83,368.34,149.84,367.77,158.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.989px 164.07px"
    },
    id: "el2qo8zo0kj5y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.28,128.11c5.89,2.82,7.23,9.31,8.6,15.11,1.92,8.09,3.69,16.22,5.07,24.41.66,3.94,1.24,7.9,1.69,11.87.44,3.8,1.14,7.86.84,11.69-.49,6.34-6.32,9.16-12,10a.21.21,0,0,1-.08-.42c3.21-.6,6.49-1.46,8.9-3.81,3.08-3,2.77-7,2.45-11-.54-6.74-1.47-13.45-2.64-20.11s-2.57-13.3-4.08-19.9c-1.44-6.28-2.44-14.54-8.84-17.8C390.18,128.17,390.21,128.08,390.28,128.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.37px 164.649px"
    },
    id: "elgosyop4xmqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.77,138.62c1.17-4.83,3.74-9.53,8.86-10.88,0,0,0,0,0,0-6.62,2-8.3,9.22-9.24,15.23q-1.49,9.48-2.26,19.06c-.51,6.14-.89,12.33-.83,18.49.06,6.64,1.2,12.88,5.07,18.4.08.11-.08.25-.17.14-3.82-4.47-5-10.59-5.29-16.31a171.64,171.64,0,0,1,.91-22.67C367.45,153,368.07,145.58,369.77,138.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.241px 163.42px"
    },
    id: "el8kqp5z9307k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.38,172.55c-5.71,7.85-28.95,24.64-38.56,23-6.27-1.05-26.09-14.67-30.27-19-4.9-5,5.34-18.24,9.15-16.62,4.75,2,20.5,14.17,24.92,15.78,2.54.92,17.86-7.21,32.92-13.17C381.37,160.29,380.79,167.86,377.38,172.55Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "343.595px 177.728px"
    },
    id: "ela75ma8yn9rs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,156.11c-3.12-1.11-6.61-2.62-10.08-2.56s-6.35,4.65-6.35,6S301,169,304.43,169s1.37-6.28,1.5-7,.26-1.64.92-1.57,12.1,5.5,12.1,5.5Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "309.3px 161.274px"
    },
    id: "el08wz4hnb8q1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.86,156.58c-.2,0-9.49-3.66-13-3.6s-6.35,4.65-6.35,6,1.31,9.49,4.78,9.49,1.37-6.28,1.5-7,.27-1.64.92-1.58,12.11,5.5,12.11,5.5Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "306.185px 160.725px"
    },
    id: "elklioo58r8ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.51,168a4.15,4.15,0,0,0,.57-2.05,6.9,6.9,0,0,0-.12-2.22,11.32,11.32,0,0,1-.42-1.9A3.82,3.82,0,0,1,303,160c.27-.48.78-.32,1.22-.16a18.65,18.65,0,0,1,1.88.85l2,1a17.93,17.93,0,0,1,2,1.11,0,0,0,0,1,0,.09,18.52,18.52,0,0,1-1.76-.79l-2-.91c-.62-.27-1.22-.58-1.85-.85-.22-.09-.66-.33-.91-.27s-.4.71-.46.92a3.31,3.31,0,0,0,.12,1.87,9.64,9.64,0,0,1,.36,1.9,5,5,0,0,1-.14,1.81,7.26,7.26,0,0,1-.83,1.49C302.57,168.12,302.46,168.05,302.51,168Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "306.299px 163.882px"
    },
    id: "elgi7cqud3gvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,165.69s-9.61-8.76-11.61-10.5c-4-3.49-20.92-10.4-23.28-10.65s-3.2,4.58,8.27,9.6c6.05,2.64,7.12,6.11,7,8s-1.95,5.49-5.18,5.41-5.32-4.8-8.29-5.33-1,4.92,1.09,8.06a19.8,19.8,0,0,0,8.68,6.78c2.8,1,11.44,4.77,11.44,4.77Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "308.687px 163.18px"
    },
    id: "elh2tyuavq43o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.07,165.31c1.21.94,2.59,2.16,4.19,2.22a3.86,3.86,0,0,0,3.49-2.36,6.08,6.08,0,0,0,.85-4.47,7.54,7.54,0,0,0-2.21-3.62,18.81,18.81,0,0,0-4.37-2.91c-.07,0,0-.13.06-.1,1.49.66,6.11,2.55,7,6.64a6.22,6.22,0,0,1-.9,4.54,4.47,4.47,0,0,1-3.32,2.66c-1.91.15-3.55-1.4-4.92-2.56C297.91,165.3,298,165.26,298.07,165.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.56px 160.993px"
    },
    id: "el0cuozy17al5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.64,175.14c-2.41-.31-11.8-8.51-15.78-11l-14,22.32c2.83,2.71,21.72,9.09,26.93,10,11.16,1.9,31-14.16,38.27-22.53,6.4-7.35,4.74-12.3.29-12.33a7.57,7.57,0,0,0-2,.29C370.45,163.4,345,175.45,342.64,175.14Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "347.575px 179.107px"
    },
    id: "elhd7cog7nj8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,187.62a8.1,8.1,0,0,1-.39-3.94,8.06,8.06,0,0,1,.39,3.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "350.286px 185.65px"
    },
    id: "eldy2hpjx2i94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.88,186.93a7.79,7.79,0,0,1-.39-3.94,8.06,8.06,0,0,1,.39,3.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "317.681px 184.96px"
    },
    id: "elra7kw8rqpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,167.36a6.91,6.91,0,0,1,1.94-.44,7,7,0,0,1,2,.05,6.91,6.91,0,0,1-1.94.44A7,7,0,0,1,366.25,167.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "368.22px 167.165px"
    },
    id: "el1pr7elah9vm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.78,180.27a7.38,7.38,0,0,1,1.94-.45,7.08,7.08,0,0,1,2,.05,7.45,7.45,0,0,1-2,.45A7.82,7.82,0,0,1,334.78,180.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "336.75px 180.065px"
    },
    id: "elqdn17gsaash",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.76,190.1a7.53,7.53,0,0,1-1.69-1.06,7.23,7.23,0,0,1-1.37-1.44,6.87,6.87,0,0,1,1.69,1.06A6.7,6.7,0,0,1,331.76,190.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "330.23px 188.85px"
    },
    id: "el02j0u7zouxzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.06,175.92a7.1,7.1,0,0,1-1.69-1.06,7,7,0,0,1-1.38-1.44,6.8,6.8,0,0,1,1.69,1.06A7,7,0,0,1,353.06,175.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "351.525px 174.67px"
    },
    id: "el3tn6q27ckev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,191.92a7.53,7.53,0,0,1-1.06,1.69,7,7,0,0,1-1.45,1.37,7.89,7.89,0,0,1,2.51-3.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.625px 193.45px"
    },
    id: "elr2xtgv0g2u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.17,176a8.11,8.11,0,0,1-2.5,3.07,6.8,6.8,0,0,1,1.06-1.69A7,7,0,0,1,362.17,176Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "360.92px 177.535px"
    },
    id: "eldzgf9dt540b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,173.14a7.89,7.89,0,0,1-2.51,3.06,7.53,7.53,0,0,1,1.06-1.69A7.27,7.27,0,0,1,326.86,173.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "325.605px 174.67px"
    },
    id: "el6v8epbhyhf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.69,167.55c-1,2-2.15,3.9-3.24,5.83s-2.21,3.86-3.33,5.77c-2.26,3.83-2.88,4.64-5.22,8.42a.1.1,0,0,1-.18-.1c2-3.95,2.56-4.83,4.8-8.67q1.64-2.81,3.35-5.57c1.21-1.93,2.36-3.91,3.7-5.75A.07.07,0,0,1,328.69,167.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.701px 177.538px"
    },
    id: "elrqs5v6teoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,173.86c-6.18,7.08-21.3,19.66-32.57,22.22l30.42-34.14.42-.12a7.57,7.57,0,0,1,2-.29C382.77,161.56,384.43,166.51,378,173.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.84px 178.805px"
    },
    id: "elgg2pr5wyep8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.13,195.24l-5.42,30.68s47.46.36,58-.31c0,0-10.54-45.38-22.44-60.47-.27-.35-.55-.68-.82-1a1.6,1.6,0,0,0-.16-.19c-5.59-6.26-12.66-4.64-17.51-.8-1.2,1-12.72,13.56-14.12,20C359.47,188.91,363.13,195.24,363.13,195.24Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "386.71px 192.886px"
    },
    id: "elyz9c5h9xqf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.74,225.61c-4.07.26-13.62.36-23.82.4-16.28.05-34.21-.09-34.21-.09l5.42-30.68s-3.66-6.33-2.44-12c1.4-6.47,12.92-19.08,14.12-20,4.06-3.22,9.68-4.87,14.68-1.65a13.71,13.71,0,0,1,2.83,2.45,1.6,1.6,0,0,1,.16.19c.27.3.55.63.82,1C405.2,180.23,415.74,225.61,415.74,225.61Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "386.725px 192.934px"
    },
    id: "eld83x3tjjtz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.33,211.58a7.94,7.94,0,0,1-.4-3.94,7.48,7.48,0,0,1,.45,1.94A7.9,7.9,0,0,1,393.33,211.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "393.13px 209.61px"
    },
    id: "elxum0jnz3tlk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,184.72a7.48,7.48,0,0,1-.45-1.94,7.08,7.08,0,0,1,.05-2,7.45,7.45,0,0,1,.45,1.95A7.84,7.84,0,0,1,383,184.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "382.796px 182.75px"
    },
    id: "elnyw9q273ss9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.09,208.8a8.1,8.1,0,0,1-.39-3.94,8.06,8.06,0,0,1,.39,3.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "366.896px 206.83px"
    },
    id: "elkpjaxftfixm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.64,202.34a7.45,7.45,0,0,1,1.95-.45,7,7,0,0,1,2,.05,7.38,7.38,0,0,1-1.94.45A7.47,7.47,0,0,1,377.64,202.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "379.615px 202.138px"
    },
    id: "el8918dwj26zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,187.42a7.45,7.45,0,0,1,2-.45,7,7,0,0,1,2,.05,7.38,7.38,0,0,1-1.94.45A7.08,7.08,0,0,1,362,187.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364px 187.222px"
    },
    id: "el0ff12ibll4lg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.78,165.72a7.45,7.45,0,0,1,2-.45,7,7,0,0,1,2,0,7.48,7.48,0,0,1-1.94.45A7.9,7.9,0,0,1,382.78,165.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "384.78px 165.493px"
    },
    id: "elct0nrdvr21p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,221.54a7.45,7.45,0,0,1,1.95-.45,7,7,0,0,1,2,0,7.38,7.38,0,0,1-1.94.45A7.47,7.47,0,0,1,363.92,221.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "365.895px 221.313px"
    },
    id: "elri85mpbsgqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,224.27a7.38,7.38,0,0,1,1.94-.45,7,7,0,0,1,2,.05,7.29,7.29,0,0,1-1.94.45A7.38,7.38,0,0,1,391,224.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "392.97px 224.068px"
    },
    id: "el768e0p61smh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.78,219.64a7.53,7.53,0,0,1-1.69-1.06,7,7,0,0,1-1.38-1.44,6.75,6.75,0,0,1,1.7,1.06A7.23,7.23,0,0,1,382.78,219.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "381.245px 218.39px"
    },
    id: "elaje3igzqoiv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,194.1a8,8,0,0,1-3.06-2.5,7.19,7.19,0,0,1,1.69,1.06A7,7,0,0,1,392.62,194.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "391.09px 192.85px"
    },
    id: "elbk1p6k8vwab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.52,177.17a6.8,6.8,0,0,1-1.69-1.06,7,7,0,0,1-1.38-1.44,6.8,6.8,0,0,1,1.69,1.06A7.26,7.26,0,0,1,376.52,177.17Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "374.985px 175.92px"
    },
    id: "el3gwr6nb03gk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.94,219a7.15,7.15,0,0,1-1.69-1.05,7.27,7.27,0,0,1-1.37-1.45,8,8,0,0,1,3.06,2.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "405.41px 217.75px"
    },
    id: "elnrmcnvcck9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.64,196.86a6.8,6.8,0,0,1-1.06,1.69,7,7,0,0,1-1.44,1.38,8.11,8.11,0,0,1,2.5-3.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "404.39px 198.395px"
    },
    id: "elk8h5hegri3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,192.28a7.1,7.1,0,0,1-1.06,1.69,7.32,7.32,0,0,1-1.45,1.38,7.1,7.1,0,0,1,1.06-1.69A7.32,7.32,0,0,1,374.84,192.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "373.585px 193.815px"
    },
    id: "elj4fu1d5u7pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.31,173.88a7.53,7.53,0,0,1-1.06,1.69,7.28,7.28,0,0,1-1.45,1.37,7.53,7.53,0,0,1,1.06-1.69A7.27,7.27,0,0,1,395.31,173.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.055px 175.41px"
    },
    id: "elvbhf1jj7lnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,162.37a7.15,7.15,0,0,1-1.05,1.69,7.27,7.27,0,0,1-1.45,1.37,8,8,0,0,1,2.5-3.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "375.18px 163.9px"
    },
    id: "elil5via4kqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.74,225.61c-4.07.26-13.62.36-23.82.4l-2.43-64.49a13.71,13.71,0,0,1,2.83,2.45,1.6,1.6,0,0,1,.16.19c.27.3.55.63.82,1C405.2,180.23,415.74,225.61,415.74,225.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.615px 193.765px"
    },
    id: "eltxe8yyowdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.66,211.26s-9.34,3.26-15.27,4.53c-3.31.71-8.87,2.43-11.06,4.06-3.28,2.44-15.43,14.74-12.51,17.75,2.64,2.73,11.74-9.17,11.74-9.17s-10.25,11.19-6.46,13.89,12.28-12.11,12.28-12.11-10.27,11.73-5.93,13.9c3.28,1.63,11.73-11.34,11.73-11.34s-8.75,10.14-5.45,12c3.65,2,12.2-9.47,12.2-9.47,9.18,3.23,16.32-1.09,20.18-3.15C389.05,231.62,376.66,211.26,376.66,211.26Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "362.766px 228.132px"
    },
    id: "el6r6rclvz92a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.24,225a48.57,48.57,0,0,0-9.39,13.08,5.21,5.21,0,0,0-.22.58c2-3,8.53-12.24,9.67-13.62C352.32,225,352.27,225,352.24,225Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "347.467px 231.83px"
    },
    id: "elc86g5tckpob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.9,228.34c-4.08,3-7.22,8.61-8.54,10.46-.1.14,0,.15.11,0,1.4-1.79,7-8.72,8.47-10.44C358,228.35,357.93,228.32,357.9,228.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.641px 233.621px"
    },
    id: "el7pryhvkl2jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.48,231.43a23.44,23.44,0,0,0-6,7.86c-.08.15,0,.14.15,0,2.07-2.79,3.3-4.56,5.93-7.76C362.6,231.47,362.53,231.39,362.48,231.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "359.51px 235.409px"
    },
    id: "elfh3248w2y0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.56,163.91c.28,6.94,10.42,39.45,10.25,40.77s-22.71,6.56-27.73,8.69c-3.41,1.45,3.16,24.25,9.72,22.06C390,232,420.87,225.49,423.49,216c2.22-8.12-18.2-39.76-23-45.59S387.33,158.17,387.56,163.91Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "396.403px 198.622px"
    },
    id: "elq6o5pfdzbuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,216.41c-3.73,12.14-40.37,21.35-40.37,21.35l-18.89-23.52s18.42-6.41,30.58-10c1.3-.38-6.47-28.79-8.21-36.36s1.13-9.32,10.65-.64S426.71,209.25,424.51,216.41Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "394.968px 199.597px"
    },
    id: "el3gdodaye8we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,198.51a7.89,7.89,0,0,1-.4-3.93,7.29,7.29,0,0,1,.45,1.94A7.82,7.82,0,0,1,414,198.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "413.8px 196.545px"
    },
    id: "elisnlx130by",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.82,219.11a7.45,7.45,0,0,1-.45-2,7,7,0,0,1,.05-2,7.38,7.38,0,0,1,.45,1.94A7.47,7.47,0,0,1,401.82,219.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "401.62px 217.11px"
    },
    id: "elzldbouisztc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.38,217.14a7.79,7.79,0,0,1-.39-3.94,8.06,8.06,0,0,1,.39,3.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "375.181px 215.17px"
    },
    id: "el5410gzed2pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.72,207.84a7.38,7.38,0,0,1,1.94-.45,7.47,7.47,0,0,1,2,.05,7.45,7.45,0,0,1-2,.45A7,7,0,0,1,418.72,207.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.69px 207.64px"
    },
    id: "elo8hb0rmelte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.91,187.52a8.06,8.06,0,0,1,3.94-.39,8.1,8.1,0,0,1-3.94.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "403.88px 187.324px"
    },
    id: "el7ap2jcq84ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.45,169.63a7.94,7.94,0,0,1,3.94-.4,7.45,7.45,0,0,1-1.95.45A7.84,7.84,0,0,1,391.45,169.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "393.42px 169.43px"
    },
    id: "el5rx92ji7r49",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.12,225.35a7.29,7.29,0,0,1,1.94-.45,7,7,0,0,1,2,0,7.89,7.89,0,0,1-3.93.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.09px 225.109px"
    },
    id: "elxz23rh2ex9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.09,209.38a7.36,7.36,0,0,1,1.94-.44,7,7,0,0,1,2,.05,7.29,7.29,0,0,1-1.94.45A7.39,7.39,0,0,1,392.09,209.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.06px 209.186px"
    },
    id: "el4v6guz868qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.05,224a7.45,7.45,0,0,1,1.94-.44,7.08,7.08,0,0,1,2,.05,7.79,7.79,0,0,1-3.94.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "379.02px 223.805px"
    },
    id: "el4oqzut5vdcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.25,217.33a7.53,7.53,0,0,1-1.69-1.06,7.27,7.27,0,0,1-1.37-1.45,7.89,7.89,0,0,1,3.06,2.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "386.72px 216.075px"
    },
    id: "ellb26jsytz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.93,234.28a7.89,7.89,0,0,1-3.06-2.51,7.53,7.53,0,0,1,1.69,1.06A7.27,7.27,0,0,1,389.93,234.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "388.4px 233.025px"
    },
    id: "ela9mop5m2cj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,176.72a7.53,7.53,0,0,1-1.69-1.06,7.05,7.05,0,0,1-1.38-1.45,7.37,7.37,0,0,1,1.7,1.06A7.56,7.56,0,0,1,405.41,176.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "403.875px 175.465px"
    },
    id: "el4w5oai2joql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.62,209.19a7.1,7.1,0,0,1-1.69-1.06,7.32,7.32,0,0,1-1.38-1.45,7.1,7.1,0,0,1,1.69,1.06A7.32,7.32,0,0,1,409.62,209.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "408.085px 207.935px"
    },
    id: "elcu8zirmqcu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.74,197.08a6.8,6.8,0,0,1-1.06,1.69,7,7,0,0,1-1.44,1.38,6.8,6.8,0,0,1,1.06-1.69A7,7,0,0,1,401.74,197.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "400.49px 198.615px"
    },
    id: "elh2r707z1x9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.32,214.82a7.1,7.1,0,0,1-1.06,1.69,7,7,0,0,1-1.44,1.38,6.77,6.77,0,0,1,1.05-1.69A7.32,7.32,0,0,1,416.32,214.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "415.07px 216.355px"
    },
    id: "elefvjdd100a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.06,223.32A6.77,6.77,0,0,1,395,225a7.32,7.32,0,0,1-1.45,1.38,7.1,7.1,0,0,1,1.06-1.69A7.26,7.26,0,0,1,396.06,223.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "394.805px 224.85px"
    },
    id: "elj90db6zc4ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,178.54a7.89,7.89,0,0,1-2.51,3.06,7.53,7.53,0,0,1,1.06-1.69A7,7,0,0,1,395.05,178.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "393.795px 180.07px"
    },
    id: "elo4nbs5cwde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,213.5c1.59,1.68,3,3.51,4.51,5.27s3,3.55,4.43,5.34c2.92,3.59,5.83,7.19,8.68,10.84a.1.1,0,0,1-.16.13c-3.11-3.42-6.11-6.94-9.05-10.52q-2.16-2.61-4.23-5.29c-1.45-1.87-3-3.71-4.29-5.67C370.6,213.52,370.7,213.43,370.76,213.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.519px 224.296px"
    },
    id: "elp8b10cmio4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.15,205.48c-2.13.63-4.22,1.14-6.33,1.83-4.21,1.38-8.4,2.84-12.58,4.32-2.4.86-4.73,1.69-7.1,2.6-.05,0,.4.54.43.57a.08.08,0,0,0,.11,0s-.27-.45-.28-.46c2-.7,4-1.3,6-2l6.32-2.08c4.22-1.36,9.15-3.07,13.34-4.52C391.66,205.58,391.74,205.31,391.15,205.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "378.345px 210.124px"
    },
    id: "el62j82swnmz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,164.27c.16-.36-9.49,12.75-18.62,10.64-4.57-1-3.89-11.67-3-12.09C379.07,160,386.73,157.57,394.81,164.27Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "383.677px 167.553px"
    },
    id: "el8hedc74sfzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.51,161.74c-.31.79-5,5.52-8.67,4.81-1.2-.23-.22-6.87-.22-6.87l0-.5-.55-7.1,8.81-4,1.27-.52s0,1.95,0,4.38c0,.11,0,.22,0,.34s0,.27,0,.4c0,.36,0,.73,0,1.1s0,.55,0,.85,0,.58,0,.88A46.24,46.24,0,0,1,387.51,161.74Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "383.11px 157.091px"
    },
    id: "elcnkizbotcmv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.13,151.93a14.3,14.3,0,0,1-9.55,7.25l-.55-7.1,8.81-4,1.27-.52S388.13,149.5,388.13,151.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.08px 153.37px"
    },
    id: "eluge065d1rpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.25,139.76c-2.88,12.14,4.06,15.25,6.68,15.87,2.38.56,10.55,2.17,14.67-9.61s-.6-17-6-18.53S373.14,127.62,370.25,139.76Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "381.364px 141.522px"
    },
    id: "eloiyhojevun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.93,138.45c.3,0,.57,0,.86,0a1.41,1.41,0,0,0,.88-.21.44.44,0,0,0,.08-.53,1.09,1.09,0,0,0-1-.43,1.57,1.57,0,0,0-1.09.4A.47.47,0,0,0,372.93,138.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.675px 137.864px"
    },
    id: "elskrl4i98b0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.41,140.12c-.28-.09-.53-.21-.8-.32a1.41,1.41,0,0,1-.76-.47.46.46,0,0,1,.09-.54,1.08,1.08,0,0,1,1.11-.07,1.58,1.58,0,0,1,.91.73C382.18,139.8,381.79,140.22,381.41,140.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.912px 139.367px"
    },
    id: "ele27ncm03rbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.26,143s.06.05.05.09c-.18.83-.26,1.81.45,2.23,0,0,0,0,0,0C378.84,145,379,143.71,379.26,143Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "379.409px 144.16px"
    },
    id: "ellxcs292hzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,142.22c1.36.15,1,2.87-.3,2.73S379,142.09,380.17,142.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.053px 143.585px"
    },
    id: "ela8l7ijxajjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,142.44c.22.19.41.5.69.57s.62-.17.87-.41c0,0,.05,0,.05,0-.07.52-.35,1-.92,1s-.82-.52-.87-1.06C380.49,142.5,380.6,142.37,380.68,142.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.395px 143.01px"
    },
    id: "elbf07ham02o6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.05,141.78s-.07,0-.07.07c-.1.84-.34,1.8-1.15,2,0,0,0,.05,0,.05C373.78,143.87,374.1,142.6,374.05,141.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.442px 142.84px"
    },
    id: "el2g64ac94iho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.42,140.8c-1.34-.29-1.82,2.4-.58,2.68S374.55,141.05,373.42,140.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.092px 142.139px"
    },
    id: "el1fbq2yp7143",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.83,140.87c-.24.11-.5.33-.76.3s-.46-.36-.6-.68c0,0,0,0-.05,0-.1.52,0,1.09.45,1.27s.84-.21,1.06-.7C373,141,372.92,140.83,372.83,140.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.171px 141.147px"
    },
    id: "elju7w414zz2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.88,149.34c-.22.18-.45.43-.76.42a2.14,2.14,0,0,1-.88-.3,0,0,0,0,0-.05,0,1.16,1.16,0,0,0,1,.56.88.88,0,0,0,.74-.67S377.92,149.31,377.88,149.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.06px 149.674px"
    },
    id: "elcyjxcg0wl1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,145.74s-.38,1.23-.48,1.82c0,.05.13.1.33.15h0a2.84,2.84,0,0,0,2.89-.61c.05,0,0-.12-.07-.1a4.29,4.29,0,0,1-2.68.33c0-.17.71-2.08.62-2.1a5.28,5.28,0,0,0-1.4.09c.71-2.58,1.83-5,2.49-7.59,0-.1-.11-.15-.15-.07a43.34,43.34,0,0,0-3,8.06C373.32,146.05,374.61,145.8,374.87,145.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.522px 142.746px"
    },
    id: "elf2qg9xxf9sb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,147.26a3.62,3.62,0,0,0,1.05,1.42,1.58,1.58,0,0,0,.9.31c.72,0,.9-.59.93-1.14a3.93,3.93,0,0,0-.07-.88A4.56,4.56,0,0,1,374.84,147.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.281px 147.98px"
    },
    id: "elhbns2y37ett",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,148.68a1.58,1.58,0,0,0,.9.31c.72,0,.9-.59.93-1.14A1.62,1.62,0,0,0,375.89,148.68Z",
    style: {
      fill: "rgb(255, 162, 190)",
      transformOrigin: "376.805px 148.396px"
    },
    id: "elz1x15v7cf7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5,146.07c-1.4-.32-4.43-4.8-3.42-11.62,0,0-.48,6.19-.17,7.16s-1.69-2.52-1-8a22.41,22.41,0,0,1-6.12,2c-2.71.29-4.29,0-4.44-.21s3.85-.79,5.08-1.81c0,0-7.42,2.07-10.64,1.79-.37,0,.44-7.67,5.88-10.07s12.65,2.35,14.41,4.72c0,0,2.4.75,4.47,4.83S393,146.41,391.5,146.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.394px 135.366px"
    },
    id: "elr2cqaic26bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.45,146.5s3.27-3.46,4.87-2.24-1.24,6.51-3.41,7a2.11,2.11,0,0,1-2.63-1.54Z",
    style: {
      fill: "rgb(221, 106, 87)",
      transformOrigin: "391.534px 147.67px"
    },
    id: "el29j1065zd46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.47,145.76a0,0,0,0,1,0,.05,5.39,5.39,0,0,0-3.22,2.9,1.18,1.18,0,0,1,1.78-.06s0,.09-.06.07a1.29,1.29,0,0,0-1.47.24,6.11,6.11,0,0,0-.85,1c-.09.11-.31,0-.24-.13l0,0C389.66,148,391.47,145.65,393.47,145.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.433px 147.881px"
    },
    id: "el51p0dmpiyrk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-77",
    className: "animable",
    style: {
      transformOrigin: "240.87px 354.22px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "167.38 292.72 167.19 307.71 165.1 421.92 162.75 421.92 160.66 307.71 160.47 292.72 167.38 292.72",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "163.925px 357.32px"
    },
    id: "eludqpxs78kdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.47 292.72 167.38 292.72 167.19 307.71 160.66 307.71 160.47 292.72",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.925px 300.215px"
    },
    id: "elkbl5gs86e3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.45 292.72 344.26 307.71 342.17 421.92 339.82 421.92 337.73 307.71 337.54 292.72 344.45 292.72",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "340.995px 357.32px"
    },
    id: "elduk9eah5b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.45 292.72 344.26 307.71 337.73 307.71 337.54 292.72 344.45 292.72",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.995px 300.215px"
    },
    id: "elj2m0qbz2hxj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.4 292.72 143.21 307.71 141.12 421.92 138.77 421.92 136.68 307.71 136.49 292.72 143.4 292.72",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "139.945px 357.32px"
    },
    id: "eliddv1nv0ga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.49 292.72 143.4 292.72 143.21 307.71 136.68 307.71 136.49 292.72",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.945px 300.215px"
    },
    id: "elx5gb39h857o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.46 292.72 320.27 307.71 318.18 421.92 315.83 421.92 313.74 307.71 313.55 292.72 320.46 292.72",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "317.005px 357.32px"
    },
    id: "elbegu1amajpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.55 292.72 320.46 292.72 320.27 307.71 313.74 307.71 313.55 292.72",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "317.005px 300.215px"
    },
    id: "elsw3g148vbpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.65,
    y: 286.52,
    width: 238.44,
    height: 9.74,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "240.87px 291.39px"
    },
    id: "elm2mv52z9jwa",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-77",
    className: "animable",
    style: {
      transformOrigin: "295.225px 269.515px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.3,
    y: 284.22,
    width: 51.4,
    height: 2.31,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "312px 285.375px"
    },
    id: "elvztbk16sfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.3,
    y: 284.22,
    width: 25.87,
    height: 2.31,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.235px 285.375px"
    },
    id: "el5jftla2lk8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.39 286.52 259.3 286.52 252.75 252.5 302.84 252.5 309.39 286.52",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "281.07px 269.51px"
    },
    id: "elib1hleu69md",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.12,269.51a2.76,2.76,0,0,1-2.79,3.05,3.4,3.4,0,0,1-3.31-3.05,2.75,2.75,0,0,1,2.78-3.05A3.39,3.39,0,0,1,284.12,269.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "281.069px 269.51px"
    },
    id: "ele9rlqjzqf8o",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-77",
    className: "animable animator-active",
    style: {
      transformOrigin: "185.781px 328.75px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "162.84 354.52 164.95 367.22 179.3 444.69 181.61 444.69 171.18 367.22 169.64 354.52 162.84 354.52",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "172.225px 399.605px"
    },
    id: "elm114oylly4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.64 354.52 162.84 354.52 164.95 367.22 171.18 367.22 169.64 354.52",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.01px 360.87px"
    },
    id: "elyoguj6um8co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.79 444.69 120.1 444.69 134.45 367.22 136.56 354.52 129.76 354.52 128.22 367.22 117.79 444.69",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "127.175px 399.605px"
    },
    id: "elyzodtjvzerr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.76 354.52 128.22 367.22 134.45 367.22 136.56 354.52 129.76 354.52",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.39px 360.87px"
    },
    id: "el73t0ke0l51e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.77 444.69 77.08 444.69 91.42 367.22 93.54 354.52 86.74 354.52 85.2 367.22 74.77 444.69",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "84.155px 399.605px"
    },
    id: "eluwpwwop73p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.2 367.22 91.42 367.22 93.54 354.52 86.74 354.52 85.2 367.22",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.37px 360.87px"
    },
    id: "el9mgnki41ofr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.43 360.49 183.54 360.49 183.54 349.41 144.19 349.41 130.97 272.48 82.44 272.48 78.43 360.49",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "130.985px 316.485px"
    },
    id: "elcxkb2xtjf94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.43 360.49 84.16 360.49 87.9 272.48 82.44 272.48 78.43 360.49",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "83.165px 316.485px"
    },
    id: "el9xc600stbfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.93,435.77c-1.95.67-57.67.86-59.8-.48-.82-.5-1.32-8.62-1.64-18.44,0,0-1.89-2.26-4.69-5.56-8.14-9.58-24-28.19-24-28.19l42.72-.24,18.81,28.43,3.12,4.73v.6s21.36,9.47,23.55,11.19S297.87,435.12,295.93,435.77Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "251.292px 409.574px"
    },
    id: "elj5ndzwdxul8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.93,435.77c-1.95.67-57.67.86-59.8-.48-.82-.5-1.32-8.62-1.64-18.44,0,0-1.89-2.26-4.69-5.56h37.51l3.12,4.73v.6s21.36,9.47,23.55,11.19S297.87,435.12,295.93,435.77Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "263.289px 423.789px"
    },
    id: "elmtizxoeg8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.93,435.77c-1.95.66-57.67.86-59.8-.48-.81-.5-1.32-8.61-1.64-18.44,0-.1,0-.21,0-.31l36-.53v.61s21.36,9.47,23.55,11.19S297.87,435.12,295.93,435.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "265.641px 426.147px"
    },
    id: "el9o9m5paipjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,433.61c-9.4-.19-47.31-.11-56.61.41-.07,0-.07.06,0,.06,9.31.4,47.22,0,56.61-.31C295.49,433.76,295.49,433.62,295.29,433.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "267.034px 433.882px"
    },
    id: "el235nu9zwf7ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,416.1c-3.69-.68-8.21-.09-11,2.55-.11.1,0,.26.16.22a52.11,52.11,0,0,1,10.86-2.3A.24.24,0,0,0,274.43,416.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "269.009px 417.358px"
    },
    id: "eldhou5wdzgd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.11,417.7c-3.7-.68-8.22-.09-11,2.55-.1.1,0,.26.16.22a52.38,52.38,0,0,1,10.86-2.3A.24.24,0,0,0,277.11,417.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "271.691px 418.958px"
    },
    id: "elipjhasp7prl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,419.3c-3.7-.68-8.22-.09-11,2.55-.11.1,0,.25.16.22a50.85,50.85,0,0,1,10.86-2.3A.24.24,0,0,0,279.78,419.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.359px 420.557px"
    },
    id: "eltnnrmvq8v1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21,408c-1.46-2-4.16-1.08-5.7.22a19.74,19.74,0,0,0-5.66,8.49.1.1,0,0,0,.09.13.46.46,0,0,0,.58.46c3.05-1.14,6.45-2,9.05-4C279.1,412.1,280.59,409.91,279.21,408Zm-6.42,6.62c-1.49.6-3,1.12-4.46,1.77a58.54,58.54,0,0,1,3.42-4.88,21.77,21.77,0,0,1,1.95-2.12c1.1-1,5.44-3.15,4.8.91C278.15,412.55,274.56,413.93,272.79,414.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "273.801px 412.077px"
    },
    id: "elg9c7fo18q5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45,415.79c3.05,1.29,6.55,1.21,9.8,1.52.33,0,.5-.33.44-.6a.1.1,0,0,0,.05-.15,19.85,19.85,0,0,0-7.69-6.71c-1.83-.85-4.67-1-5.56,1.29S256.67,415,258.45,415.79Zm-1.68-2.63c-1.67-3.75,3.08-2.81,4.4-2.13a21.31,21.31,0,0,1,2.44,1.54,57.79,57.79,0,0,1,4.58,3.81c-1.58-.24-3.17-.35-4.76-.54C261.53,415.62,257.7,415.23,256.77,413.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.017px 413.294px"
    },
    id: "elebv0ei59kh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.14,416.24l-21.71,2.13L231,420.48s-43.51-56.37-46.17-59c-6-6-53.73-20.5-66.76-33.45-13.8-13.71-7.78-31.05-7.78-31.05h36s-.09,14.05,1.83,14.65c20.78,6.46,60,20.6,69,28.55C233.22,354.4,274.14,416.24,274.14,416.24Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "191.562px 358.73px"
    },
    id: "el8gu80x8dhek",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,409.62c-6.11.57-4.37.32-10.46,1-3,.31-22.59,2.4-25.32,3.19-.07,0,0,.12,0,.12,2.84.14,22.4-2.29,25.38-2.66,6.09-.77,4.33-.61,10.41-1.44A.09.09,0,0,0,267.38,409.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.53px 411.778px"
    },
    id: "elwlmj2jjv1nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.43,418.37,231,420.48s-43.51-56.37-46.17-59c-6-6-53.73-20.5-66.76-33.45-13.8-13.71-7.78-31.05-7.78-31.05H124.5l2.27.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.707px 358.73px"
    },
    id: "el03higu1niff6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.06,447.34c-1.95.63-57.67-.09-59.78-1.47-.81-.5-1.17-8.63-1.34-18.46v-.31c0-2-.06-4.11-.07-6.22,0-.29,0-.59,0-.88-.07-14.18.15-28.9.15-28.9l37.27.37-1.12,28.64,0,1.13-.22,5.93,0,.61s21.21,9.81,23.36,11.57S227,446.72,225.06,447.34Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "194.902px 419.335px"
    },
    id: "eleih27qyn8r6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.06,447.34c-1.95.63-57.67-.09-59.78-1.47-.81-.5-1.17-8.63-1.34-18.46v-.31c0-2-.06-4.11-.07-6.22,0-.29,0-.59,0-.88l36.3.11,0,1.13-.22,5.93,0,.61s21.21,9.81,23.36,11.57S227,446.72,225.06,447.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.909px 433.785px"
    },
    id: "elfiaphiyq7z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.06,447.34c-1.95.63-57.67-.09-59.78-1.47-.81-.5-1.17-8.63-1.34-18.46v-.31l36,.07,0,.61s21.21,9.81,23.36,11.57S227,446.72,225.06,447.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "194.942px 437.335px"
    },
    id: "elm3iocjcvof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,445.17c-9.39-.35-47.3-.88-56.61-.52-.07,0-.07.06,0,.06,9.3.55,47.21.78,56.61.62C224.65,445.32,224.66,445.18,224.46,445.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.202px 444.955px"
    },
    id: "elx1km1vezcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.9,427.32c-3.69-.74-8.22-.23-11.08,2.37-.11.1,0,.26.16.22a51.68,51.68,0,0,1,10.89-2.12A.24.24,0,0,0,203.9,427.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.427px 428.463px"
    },
    id: "eloq06bb7iw78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.54,429c-3.69-.73-8.21-.23-11.07,2.37-.11.1,0,.26.15.22a52.41,52.41,0,0,1,10.9-2.12A.24.24,0,0,0,206.54,429Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "201.074px 430.146px"
    },
    id: "elkdzs2egx29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19,430.61c-3.69-.74-8.22-.23-11.07,2.36-.12.1,0,.26.15.22a52.41,52.41,0,0,1,10.9-2.12A.23.23,0,0,0,209.19,430.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.74px 431.748px"
    },
    id: "elj3hfuynw9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.81,419.32c-1.43-2-4.15-1.15-5.71.12a19.81,19.81,0,0,0-5.8,8.4.1.1,0,0,0,.09.13.46.46,0,0,0,.57.47c3.07-1.09,6.48-1.88,9.12-3.88C208.62,423.4,210.16,421.23,208.81,419.32Zm-6.54,6.52c-1.49.57-3,1.07-4.48,1.69a56.77,56.77,0,0,1,3.49-4.82,21.9,21.9,0,0,1,2-2.09c1.11-1,5.49-3.06,4.79,1C207.67,423.83,204.05,425.15,202.27,425.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.312px 423.291px"
    },
    id: "elnkdon0k1x2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.92,426.75c3,1.34,6.53,1.32,9.77,1.67.33,0,.51-.31.45-.59a.1.1,0,0,0,.05-.15,19.72,19.72,0,0,0-7.58-6.83C188.8,420,186,419.75,185,422S186.15,426,187.92,426.75Zm-1.63-2.66c-1.62-3.77,3.12-2.76,4.43-2.06a21.26,21.26,0,0,1,2.41,1.58c1.62,1.18,3,2.56,4.52,3.89-1.58-.27-3.17-.41-4.76-.62C191,426.63,187.18,426.17,186.29,424.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "191.476px 424.329px"
    },
    id: "el8dl9nyj85xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42,427.29l-40.58.9s4.94-59.63,4-64.85c-.41-2.42-49-9.53-64.59-25.89C86.88,323.37,99.24,297,99.24,297L136,296s1.21,11.32-1.42,18.34c0,0,57.37,13.77,63.81,26.36C205.27,354.13,201.42,427.29,201.42,427.29Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "148.264px 362.095px"
    },
    id: "el94ajg3vr6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,357.85c-.26-3.3-.64-6.59-1.18-9.86-.28-1.62-.58-3.24-1-4.84a15.37,15.37,0,0,0-1.48-4.24c-1.45-2.52-4.12-4.12-6.56-5.54a66.3,66.3,0,0,0-8.27-4c-5.87-2.4-12-4.24-18-6.18-3.64-1.16-7.27-2.33-10.92-3.46s-7.46-2.15-11.16-3.36c-.08,0-.1.1,0,.13,3.23,1.08,6.4,2.33,9.61,3.48s6.29,2.22,9.44,3.29l9.4,3.21c2.92,1,5.86,2,8.75,3.07a77.42,77.42,0,0,1,8.23,3.65,27.61,27.61,0,0,1,7.16,4.74c2.14,2.19,2.59,5.37,3.16,8.24.65,3.27,1.1,6.56,1.45,9.87.76,7.31,1.32,14.19,1.62,21.52,0,.49.26.9.27.41C202.6,371.27,202.47,364.54,202,357.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.952px 347.285px"
    },
    id: "el96tf0d6pmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.8,362.82a2.65,2.65,0,0,0-1.77-1.9c-2.3-1.06-4.67-2-7-2.84-9.39-3.48-19.09-6-28.55-9.23a118.43,118.43,0,0,1-14.07-5.72c-2.23-1.1-4.42-2.3-6.54-3.61a35.7,35.7,0,0,1-6.28-4.72c-8-7.84-7.48-19.9-5.68-30.09.25-1.39.51-2.77.78-4.16a.07.07,0,0,0-.13,0c-1.94,10.05-4,21.36,1.63,30.65,2.6,4.29,6.82,7.18,11.07,9.67a93.25,93.25,0,0,0,13.68,6.44c9.36,3.59,19.09,6.12,28.6,9.28,2.44.8,4.86,1.65,7.25,2.57,1.18.46,2.36.93,3.53,1.42s2.79.87,3.14,2.15a5.61,5.61,0,0,1,0,1.83c0,.76-.11,1.52-.16,2.28l-.31,4.44q-.31,4.39-.62,8.77-1.25,17.66-2.47,35.31c-.1,1.44-.2,2.88-.29,4.32,0,.17.24.15.26,0q1.3-17.59,2.52-35.19.63-8.83,1.25-17.66l.15-2A8.31,8.31,0,0,0,169.8,362.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.195px 360.153px"
    },
    id: "elv69alwufd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,303.51c0-.07-.14-.06-.13,0a12.85,12.85,0,0,1-.39,5.31,7.56,7.56,0,0,1-2.51,3.35c-2.66,2.14-6,2.42-9.22,3.25-.15,0-.13.28,0,.27,3.42,0,7.19-.79,9.9-3a7.87,7.87,0,0,0,2.55-3.64A10.14,10.14,0,0,0,112.88,303.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.949px 309.576px"
    },
    id: "elzjyzn9svpl8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,420.84c-6.13-.06-4.37-.13-10.5-.11-3,0-22.72.07-25.51.57a.06.06,0,0,0,0,.12c2.81.43,22.52,0,25.52,0,6.13-.13,4.37-.16,10.5-.36A.09.09,0,0,0,199.82,420.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.843px 421.169px"
    },
    id: "elkjocjnox3rs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.35,298.48c-.18,2.25-.31,4.51-.58,6.75-.13,1.06-.23,2.13-.43,3.17a2.08,2.08,0,0,1-.57,1.21,2.47,2.47,0,0,1-1.36.46,1.47,1.47,0,0,1-1.83-1.43c-.19-2.05.41-9.18.42-9.76,0-.12-.37-.12-.39,0-.55,4.5-1.29,10.23-.34,11.21a3,3,0,0,0,3.91.27,2.85,2.85,0,0,0,.85-1.83c.15-1,.19-2,.26-3,.18-2.35.38-4.7.43-7.06C136.72,298.28,136.36,298.27,136.35,298.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.766px 304.642px"
    },
    id: "elb23h4u5283",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.2,310.8a8,8,0,0,0-.17.85c-.06.29-.12.57-.19.85s-.13.57-.21.86-.12.56-.18.85a.11.11,0,0,0,.2.07,8.08,8.08,0,0,0,.35-.8c.09-.29.18-.57.26-.86s.14-.57.2-.86a3.77,3.77,0,0,0,.15-.89C135.61,310.67,135.27,310.59,135.2,310.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.03px 312.502px"
    },
    id: "eltbrpuwk52sq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,263.91c.48,10,4.64,43.15,13.15,48.35,5.59,3.41,30.81,9.54,37,5.23,2.71-1.88,5.71-20.5,2.22-20.93s-24-4.66-26.12-6.2-13-28.53-17.89-36C137.69,241.43,137.56,258.53,137.82,263.91Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "164.762px 284.301px"
    },
    id: "elkfft0vdbqp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.26,292.72l-8.65,26.54s-20.56-3.2-27.72-9.28c-8.69-7.37-11.3-44.18-11.32-50.07,0-9.67,2.85-14.4,7.05-11.34,1.63,1.18,3.47,3.54,5.4,7.26,2,3.88,12.84,28.18,17.12,33.64C167.53,292.53,183.26,292.72,183.26,292.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "159.415px 283.453px"
    },
    id: "el6ijyxxib58j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.26,292.72l-8.65,26.54s-3.41-.53-7.94-1.57c-6.59-1.52-15.54-4.11-19.78-7.71-8.69-7.37-11.3-44.18-11.32-50.07,0-7,1.48-11.41,3.91-12.15a3.54,3.54,0,0,1,3.14.81c1.63,1.18,3.47,3.54,5.4,7.26,2,3.88,12.84,28.18,17.12,33.64C167.53,292.53,183.26,292.72,183.26,292.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "159.415px 283.466px"
    },
    id: "elxyy7vs673r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,316.44c1.16-4,6.51-20,7.89-23.38.1-.23.27-.23.2,0-3.19,12-6.59,19.56-7.93,23.39C170.23,316.57,170.07,316.54,170.1,316.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "174.151px 304.708px"
    },
    id: "elz4aohkz53od",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67,317.69c-6.59-1.52-15.54-4.11-19.78-7.71-8.69-7.37-11.3-44.18-11.32-50.07,0-7,1.48-11.41,3.91-12.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.12px 282.725px"
    },
    id: "el5udw5iqfe8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,311.77c-1.38,1.14-58.38,1.82-58.62,1.42s15.57-60.82,36.42-68.3c3.31-1.18,11.94-.32,12.87.93C148.44,256.22,150.89,311,150,311.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "120.775px 278.817px"
    },
    id: "elkjm3kdw94w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,254.1c-3.21.15-7.59-5.53-9-9.71-.09-.29.82-3,1.78-6.26.57-2,1.16-4.25,1.56-6.33l12.49,5.63a33.7,33.7,0,0,0-2.77,7.78,4.37,4.37,0,0,0-.07.87.71.71,0,0,1,0,.14C140.94,247.9,140.05,254,137,254.1Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "135.912px 242.951px"
    },
    id: "elne23omd2lzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.83,237.43a33.7,33.7,0,0,0-2.77,7.78,4.37,4.37,0,0,0-.07.87.71.71,0,0,1,0,.14,7,7,0,0,1-1.36-.18c-7.58-1.6-8-11.43-7.92-14.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.766px 239.09px"
    },
    id: "elq8nt5ec0x7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,215.48c-3.41,3.57-7.31,16.88-5.68,21.1,2.37,6.13,9.3,10.09,15.27,6.55,5.8-3.44,10.58-20.86,8.47-25C152.05,212,142.13,210.21,137.09,215.48Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "143.343px 228.417px"
    },
    id: "elm8yba0nloac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,223.77c-5.36,1.59-9.89-4.9-9.89-4.9a5,5,0,0,1-5.81,1.45s-3.27,7.14-5.22,6.49c-3-1-.62-11.4,1-13.09a5.6,5.6,0,0,1,4.28-1.37,5.13,5.13,0,0,1,3-2.3c2.54-.89,8.89,3.48,8.89,3.48a6.88,6.88,0,0,1,2.59-1.84,1.92,1.92,0,0,1,2.57,1.1,4.61,4.61,0,0,0-1.31,1.6c-1.05,2.06.72,2.63,1.35.65a3.23,3.23,0,0,0,0-2.25c1.29-1,2.86-1,3.51,0C161,214.56,159.44,222.46,155,223.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.457px 218.391px"
    },
    id: "elnnah2dgjdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45,229.21s-.08,0-.09.06c-.22.91-.61,1.9-1.5,2,0,0,0,.05,0,.05C144.88,231.43,145.39,230.1,145.45,229.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "144.655px 230.268px"
    },
    id: "el47xbwlpqps2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.9,228.06c-1.41-.5-2.3,2.36-1,2.82S146.09,228.48,144.9,228.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "144.363px 229.466px"
    },
    id: "el7r1ds20eai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,230.83s.06.07,0,.1c-.3.88-.5,1.93.2,2.48a0,0,0,0,1,0,.05C149.94,233,150.22,231.61,150.65,230.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.549px 232.145px"
    },
    id: "elu06c4cv5n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.73,230.16c1.46.34.67,3.22-.68,2.91S150.51,229.87,151.73,230.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.431px 231.616px"
    },
    id: "elwjzhq9ip07i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,226.4a9.88,9.88,0,0,0,1.22,0,2,2,0,0,0,1.25-.28.64.64,0,0,0,.13-.76,1.54,1.54,0,0,0-1.46-.63,2.3,2.3,0,0,0-1.57.55A.68.68,0,0,0,144.19,226.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "145.228px 225.567px"
    },
    id: "eltzohdofwwlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29,229.06a8.73,8.73,0,0,1-1-.65c-.39-.25-.74-.41-.93-.86a.64.64,0,0,1,.26-.73,1.56,1.56,0,0,1,1.58.19,2.31,2.31,0,0,1,1.08,1.26A.67.67,0,0,1,153.29,229.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.824px 227.926px"
    },
    id: "el4slmb3jwrw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.06,236.74a1.42,1.42,0,0,0,.43.85,2.39,2.39,0,0,0,1,.27s.05,0,0,.06a1.26,1.26,0,0,1-1.28-.12,1,1,0,0,1-.25-1.07S142.05,236.7,142.06,236.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.705px 237.38px"
    },
    id: "elwtfhr4ve11",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,234.54a3.14,3.14,0,0,0,1.6,2,3.55,3.55,0,0,0,1.06.39l.42.08a.24.24,0,0,0,.24-.15h0l.54-1.91c.21.2,1.3,1.17,1.39.81a47.43,47.43,0,0,0,1.69-9.49c0-.1-.15-.13-.17,0-.83,2.86-1.16,5.84-2,8.73a5.44,5.44,0,0,0-1.28-.88c-.06,0-.6,2.36-.61,2.38a4.41,4.41,0,0,1-2.82-1.95C144,234.42,143.94,234.46,144,234.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.458px 231.597px"
    },
    id: "elpieir6aenom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,231.26c.64-2,2.23-3.24,3.54-2.82s1.85,2.38,1.2,4.36-2.23,3.24-3.53,2.81S149.25,233.23,149.89,231.26Zm.48.15c-.56,1.71-.16,3.38.88,3.72s2.35-.78,2.9-2.49.16-3.38-.88-3.72S150.93,229.7,150.37,231.41Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "152.264px 232.026px"
    },
    id: "eltdjurgyw4vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.87,228.33a3.53,3.53,0,1,1,2.19,4.67A3.66,3.66,0,0,1,140.87,228.33Zm.48.15a3,3,0,1,0,3.88-2.17A3.16,3.16,0,0,0,141.35,228.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "144.167px 229.642px"
    },
    id: "elymzdv65xzrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,230.13c2,0,2.62.8,2.62.81l.42-.28s-.75-1.09-3.06-1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "149.03px 230.297px"
    },
    id: "elkhtzurs3xod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.22,228.09l.24-.44c-.29-.16-7.17-3.89-8-4.2s-3.13.15-3.39.2l.1.49a9.81,9.81,0,0,1,3.08-.23l0,0C133.92,224.16,138.75,226.75,141.22,228.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "135.765px 225.717px"
    },
    id: "el8anqmqo4lg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.81,227.7s-.87-5.31-3.15-5.18-2.95,6.9-1.21,8.7a2.39,2.39,0,0,0,3.44.22Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "132.138px 227.293px"
    },
    id: "el08tomrzc5wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,224.47s-.06,0,0,.05a6,6,0,0,1,1.19,4.75A1.31,1.31,0,0,0,131,228.1a.05.05,0,0,0,0,.1,1.47,1.47,0,0,1,1.24,1.16,7.57,7.57,0,0,1,.13,1.51c0,.17.28.21.3,0v0C133.66,229,133.46,225.63,131.51,224.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.101px 227.741px"
    },
    id: "el77ehzdzt7ht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.86,245.93l-3.44,7.6-9.2-10.2-2.86,3s8.74,16,8.83,15.26l3.48-6.54,4.4,4.84.13-11.67Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "133.78px 252.472px"
    },
    id: "elm2y9j77n5er",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.46,254.16c0-1.93,0-3.87-.17-5.8,0-.06-.11-.1-.13,0-.46,1.84-.26,9.21-.34,11l0,0c-.18-.21-4.09-4.27-4.13-4.21-.74,1-3.29,5.79-3.47,6.22-1.38-2.53-7.28-12.54-8.94-15a.07.07,0,0,0-.12.06c1.21,2.67,8.81,15.88,8.93,15.85a76.6,76.6,0,0,0,3.64-6.91c.65.87,4.58,5.43,4.6,5.15A60.8,60.8,0,0,0,142.46,254.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.825px 254.314px"
    },
    id: "elo3wy40v7bxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.75,267.37s-3.24-4.4-.06-6.37,5.67,2.9,5.67,2.9Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "135.826px 263.95px"
    },
    id: "eljiy42dc07i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45,296.39h0l.39,5.33.13,1.76-1.52-.9-4.61-2.73h0l-20.2-32.68,5.6-3.46,20.21,32.67Z",
    style: {
      fill: "rgb(9, 65, 108)",
      transformOrigin: "146.805px 283.595px"
    },
    id: "el2o086b5l4gu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.84 301.73 159.97 303.49 158.44 302.59 159.84 301.73",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "159.205px 302.61px"
    },
    id: "elpkqd3h1p0op",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxfpg5ftvrm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.89,
    y: 265.16,
    width: 7.7,
    height: 1.53,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "136.74px 265.925px",
      transform: "rotate(-31.73deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely7klk32995"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.77,
    y: 266.6,
    width: 7.7,
    height: 1.53,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.62px 267.365px",
      transform: "rotate(-31.73deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.75 270.04 136.86 268.73 143.01 281.27 142.2 281.71 134.75 270.04",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.88px 275.22px"
    },
    id: "elkposaz2c15m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.35,256.89C95.93,273.78,77.78,303,85.18,309.58c6.76,6,32.37,1.42,48.57-4.27,3.09-1.08-8.3-28.42-11.46-26.93a88.48,88.48,0,0,1-10.28,4.2c-.88.2,4.54-10.6,10.28-23.1C128.7,245.53,121.73,247.24,112.35,256.89Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "108.877px 280.868px"
    },
    id: "elr9b9qmk67dg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.2,277.74c-.1,3.13-7.79,2.24-7.79,2.24a5.8,5.8,0,0,1,2.24,3.23c.5,2.32-2.93,4.13-2.93,4.13a7.15,7.15,0,0,1,1.82,3.78c.26,2.27-2.94,4.59-2.94,4.59a6.23,6.23,0,0,1-.5,4.33c-2,3.5-8.12,3.35-12,4a80.69,80.69,0,0,0-12.63,3.54l-6.09-28.35s16.86-9.23,21.47-8.84C145.77,270.73,161.34,273,161.2,277.74Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "140.79px 288.979px"
    },
    id: "ela9dbxtw3gw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.35,279.89a52.82,52.82,0,0,0-12.61-2,.08.08,0,0,0,0,.15c4.19.25,8.41,1.63,12.58,2A.1.1,0,0,0,153.35,279.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.03px 278.965px"
    },
    id: "elao0dvdowog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.62,287a11.16,11.16,0,0,0-2.89-.27c-1,0-2.06,0-3.09,0q-3.09,0-6.17.22c-.09,0-.11.15,0,.15,2,0,4.11,0,6.16.06l3.08.12a12.79,12.79,0,0,0,2.9,0A.15.15,0,0,0,152.62,287Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.553px 287.042px"
    },
    id: "elrzxt3440p8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.51,295.71a7.61,7.61,0,0,0-2.61-.1l-2.82.07c-1.88,0-3.75.08-5.63.05-.09,0-.1.15,0,.15,1.91,0,3.81.1,5.72.12H149a7.28,7.28,0,0,0,2.55-.21A0,0,0,0,0,151.51,295.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "145.964px 295.787px"
    },
    id: "el6nrh72t14gb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.62,249.72c-11.67,6.48-42.3,46.54-37.45,58.13s42,.79,42,.79l-1.81-30.93s-9.88,5-10.18,4.47,8.46-19,11-24.58S126.83,246.27,120.62,249.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "104.233px 280.946px"
    },
    id: "el8c5o43982xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63,306.69c-.49-4.1-1.88-20.94-1.93-24.6,0-.25.16-.32.19,0,1.77,12.24,1.63,20.58,1.9,24.62A.08.08,0,0,1,120.63,306.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.745px 294.328px"
    },
    id: "elk8n0sm7fhs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.15,277.73A22.71,22.71,0,0,0,120,279c-.92.41-1.85.82-2.77,1.25-2,.92-4,1.89-5.94,2.87s-3.93,2-5.87,3-3.82,2.18-5.76,3.21c-.09.05,0,.18.08.13,2-1,4-1.87,6-2.82l5.86-2.8,5.85-2.79,2.86-1.39a24.13,24.13,0,0,0,3-1.57A.22.22,0,0,0,123.15,277.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.491px 283.601px"
    },
    id: "elvji1uzwjzzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.33,268.74c-.63.73-1.24,1.46-1.83,2.22-.11.14-.21.29-.31.43.17-.4.34-.79.5-1.19a40.3,40.3,0,0,0,1.73-4.2c0-.07-.08-.1-.12,0a43.94,43.94,0,0,0-2.12,4.23c-.67,1.39-1.35,2.78-2,4.18s-1.3,2.8-1.91,4.22a29.62,29.62,0,0,0-1.67,4.24c0,.08.1.12.14.05a31.71,31.71,0,0,0,2.19-4.21c.66-1.39,1.27-2.81,1.91-4.21.27-.59.53-1.18.78-1.78l.32-.39c.29-.36.57-.74.84-1.12.55-.78,1.07-1.59,1.58-2.4C120.39,268.75,120.35,268.72,120.33,268.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.51px 274.446px"
    },
    id: "elydmas9md4gh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,308a2.93,2.93,0,0,0,0,.68c-4.28.85-8.64,1.89-12.94,2.65A121.1,121.1,0,0,1,99,313a44.73,44.73,0,0,1-7.5-.18c-.1,0-.1.15,0,.16a74.93,74.93,0,0,0,13.31.23A116,116,0,0,0,117.93,311c2.46-.54,4.93-1,7.37-1.7C125.42,309.27,125.2,308,125.15,308Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.38px 310.701px"
    },
    id: "ely6oehwk3jv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.93 320.68 141.55 318.44 159.54 277.95 191.91 280.18 173.93 320.68",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "166.73px 299.315px"
    },
    id: "elsza85lcf1lh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.15 320.83 143.77 318.59 161.75 278.1 194.13 280.34 176.15 320.83",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "168.95px 299.465px"
    },
    id: "elumj96o2qvw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.19,278.34a2.85,2.85,0,0,1-1.5,1.6c-.32.14-.38-.27-.06-.4a2.13,2.13,0,0,0,1-1,2.18,2.18,0,0,0,.09-.23,1.56,1.56,0,0,0,.11-.78.53.53,0,0,0-.17-.3,0,0,0,0,1,0,0l0,0-.06,0a.36.36,0,0,0-.23,0,.83.83,0,0,0-.39.21,1.91,1.91,0,0,0-.35.41,1.88,1.88,0,0,0-.16.23l0,.05,0,.08s0,0,0,.06l-.46,0a3.43,3.43,0,0,1,.49-.77,1.78,1.78,0,0,1,1.3-.7.72.72,0,0,1,.68.71A1.91,1.91,0,0,1,165.19,278.34Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "164.245px 278.384px"
    },
    id: "elo9haqjyagm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.73,278.52a2.86,2.86,0,0,1-1.51,1.59c-.32.15-.37-.26-.06-.4a2.15,2.15,0,0,0,1-1l.09-.22a1.59,1.59,0,0,0,.1-.79.49.49,0,0,0-.16-.3l0,0,0,0h-.06a.36.36,0,0,0-.23,0,1.07,1.07,0,0,0-.39.21,2.63,2.63,0,0,0-.35.41c-.06.07-.1.15-.16.23l0,.06a.56.56,0,0,0-.05.08s0,0,0,.05l-.46,0a3.56,3.56,0,0,1,.49-.77,1.76,1.76,0,0,1,1.3-.7.71.71,0,0,1,.68.71A1.92,1.92,0,0,1,167.73,278.52Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "166.725px 278.556px"
    },
    id: "el45z4i7c5zbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.26,278.69a2.89,2.89,0,0,1-1.5,1.6c-.32.14-.38-.27-.06-.4a2,2,0,0,0,1.1-1.23,1.45,1.45,0,0,0,.1-.78.47.47,0,0,0-.16-.3l0,0,0,0-.07,0a.34.34,0,0,0-.22,0,.83.83,0,0,0-.39.21,1.66,1.66,0,0,0-.35.41,1.88,1.88,0,0,0-.16.23l0,.05a.59.59,0,0,0,0,.08s0,0,0,.06l-.46,0a3.48,3.48,0,0,1,.5-.77,1.78,1.78,0,0,1,1.3-.7.7.7,0,0,1,.67.71A1.79,1.79,0,0,1,170.26,278.69Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "169.325px 278.734px"
    },
    id: "el7by6q5v8lei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.79,278.87a2.81,2.81,0,0,1-1.5,1.59c-.32.15-.37-.26-.06-.4a2.32,2.32,0,0,0,1.11-1.22,1.59,1.59,0,0,0,.1-.79.55.55,0,0,0-.16-.3l0,0s0,0,0,0h-.06a.36.36,0,0,0-.23,0,.93.93,0,0,0-.39.21,2.63,2.63,0,0,0-.35.41,1.88,1.88,0,0,0-.16.23l0,.06a.22.22,0,0,0,0,.08.08.08,0,0,0,0,.05l-.46,0a3.22,3.22,0,0,1,.49-.77,1.75,1.75,0,0,1,1.3-.7.71.71,0,0,1,.68.71A1.93,1.93,0,0,1,172.79,278.87Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "171.865px 278.906px"
    },
    id: "elss58jir2cag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.33,279a2.91,2.91,0,0,1-1.51,1.6c-.32.14-.37-.27,0-.4a2,2,0,0,0,1.1-1.23,1.45,1.45,0,0,0,.1-.78.47.47,0,0,0-.16-.3l0,0,0,0-.06,0a.37.37,0,0,0-.23,0,.85.85,0,0,0-.38.21,2,2,0,0,0-.36.41c-.06.07-.1.15-.16.23l0,0a.3.3,0,0,0,0,.08s0,0,0,.06l-.46,0a3.48,3.48,0,0,1,.5-.77,1.73,1.73,0,0,1,1.29-.7.71.71,0,0,1,.68.71A1.79,1.79,0,0,1,175.33,279Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "174.445px 279.019px"
    },
    id: "el1av4oxcuyoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.86,279.22a2.84,2.84,0,0,1-1.5,1.59c-.32.15-.38-.26-.06-.4a2.13,2.13,0,0,0,1-1,2,2,0,0,0,.09-.22,1.6,1.6,0,0,0,.11-.79.56.56,0,0,0-.17-.3v0l0,0h-.06a.36.36,0,0,0-.23,0,.93.93,0,0,0-.39.21,2.18,2.18,0,0,0-.35.41,1.88,1.88,0,0,0-.16.23l0,.06a.2.2,0,0,0,0,.08s0,0,0,0l-.46,0a3.22,3.22,0,0,1,.49-.77,1.79,1.79,0,0,1,1.3-.71.73.73,0,0,1,.68.72A1.93,1.93,0,0,1,177.86,279.22Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "176.915px 279.226px"
    },
    id: "el4vtzlmoydc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,279.39a2.91,2.91,0,0,1-1.51,1.6c-.32.14-.37-.27-.06-.4a2.15,2.15,0,0,0,1-1l.09-.23a1.57,1.57,0,0,0,.1-.79.47.47,0,0,0-.16-.29l0,0,0,0-.06,0a.37.37,0,0,0-.23,0,.94.94,0,0,0-.39.21,2.24,2.24,0,0,0-.35.41c-.06.07-.1.15-.16.23l0,.05-.05.08s0,0,0,.06l-.46,0a3.82,3.82,0,0,1,.49-.77,1.76,1.76,0,0,1,1.3-.7.71.71,0,0,1,.68.71A1.9,1.9,0,0,1,180.4,279.39Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "179.395px 279.434px"
    },
    id: "elxgwczmjzxeb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.93,279.57a2.87,2.87,0,0,1-1.5,1.59c-.32.15-.38-.26-.06-.4a2.18,2.18,0,0,0,1-1,2,2,0,0,0,.09-.22,1.48,1.48,0,0,0,.1-.79.49.49,0,0,0-.16-.3l0,0,0,0h-.07a.33.33,0,0,0-.22,0,.93.93,0,0,0-.39.21,1.66,1.66,0,0,0-.35.41,1.88,1.88,0,0,0-.16.23l0,.06a.2.2,0,0,0,0,.08.09.09,0,0,0,0,.05l-.46,0a3.27,3.27,0,0,1,.5-.77,1.79,1.79,0,0,1,1.3-.71.71.71,0,0,1,.67.72A1.82,1.82,0,0,1,182.93,279.57Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "181.985px 279.601px"
    },
    id: "elbs9mad874tb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.46,279.74a2.85,2.85,0,0,1-1.5,1.6c-.32.14-.37-.27-.06-.4a2.13,2.13,0,0,0,1-1c0-.08.07-.16.1-.23a1.57,1.57,0,0,0,.1-.79.52.52,0,0,0-.16-.29l0,0s0,0,0,0l-.06,0a.37.37,0,0,0-.23,0,.83.83,0,0,0-.39.21,2.24,2.24,0,0,0-.35.41c-.06.07-.1.15-.16.23l0,.05a.35.35,0,0,0-.05.08.14.14,0,0,0,0,.06l-.46,0a3.43,3.43,0,0,1,.49-.77,1.75,1.75,0,0,1,1.3-.7.71.71,0,0,1,.68.71A1.91,1.91,0,0,1,185.46,279.74Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "184.475px 279.784px"
    },
    id: "el5cb2tjgzr6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,279.92a2.89,2.89,0,0,1-1.51,1.59c-.32.15-.37-.26-.05-.4a2.18,2.18,0,0,0,1-1,2,2,0,0,0,.09-.22,1.48,1.48,0,0,0,.1-.79.49.49,0,0,0-.16-.3l0,0,0,0h-.06a.36.36,0,0,0-.23,0,1,1,0,0,0-.38.21,2,2,0,0,0-.36.41c-.06.07-.1.15-.16.23l0,.06a.2.2,0,0,0,0,.08.09.09,0,0,0,0,.05l-.46,0a3.27,3.27,0,0,1,.5-.77,1.77,1.77,0,0,1,1.29-.71.72.72,0,0,1,.68.72A1.82,1.82,0,0,1,188,279.92Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "187.055px 279.951px"
    },
    id: "elk46dcesuejp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.53,280.09a2.85,2.85,0,0,1-1.5,1.6c-.32.14-.38-.27-.06-.4a2.13,2.13,0,0,0,1-1c0-.08.07-.16.09-.23a1.58,1.58,0,0,0,.11-.79A.54.54,0,0,0,190,279a0,0,0,0,1,0,0l0,0-.06,0a.36.36,0,0,0-.23,0,.83.83,0,0,0-.39.21,1.91,1.91,0,0,0-.35.41,1.88,1.88,0,0,0-.16.23l0,.05,0,.08s0,0,0,.06l-.46,0a3.43,3.43,0,0,1,.49-.77,1.75,1.75,0,0,1,1.3-.7.72.72,0,0,1,.68.71A1.91,1.91,0,0,1,190.53,280.09Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "189.585px 280.144px"
    },
    id: "el4t5oezohhth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,280.27a2.89,2.89,0,0,1-1.51,1.59c-.32.15-.37-.26-.06-.4a2.15,2.15,0,0,0,1-1l.09-.22a1.59,1.59,0,0,0,.1-.79.49.49,0,0,0-.16-.3l0,0,0,0h-.06a.36.36,0,0,0-.23,0,1.07,1.07,0,0,0-.39.21,2.24,2.24,0,0,0-.35.41c-.06.07-.1.15-.16.23l0,.06a.56.56,0,0,0-.05.08s0,0,0,.05l-.46,0a3.56,3.56,0,0,1,.49-.77,1.81,1.81,0,0,1,1.3-.71.72.72,0,0,1,.68.72A1.94,1.94,0,0,1,193.07,280.27Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "192.065px 280.301px"
    },
    id: "elv5d8f84t6n8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,290.32c1.08,3.74,4.54,8.74,4.43,11.63a3.32,3.32,0,0,1-2.39,3.17s2.61,1.88,2.07,4.49c-.28,1.34-2.67,2.08-2.67,2.08a4,4,0,0,1,1.4,3.88c-.5,1.83-2.82,2.29-2.82,2.29s1.23,2.43.12,4.13c-2.23,3.44-18.27.85-19.79-5.46-.71-2.94,3.17-2.09,3.17-2.09s-5.29-2.57-4.84-5.89,5.43-1.92,5.43-1.92-5.11-2.53-4.29-5.92,5.58-1.28,5.58-1.28-3.17-3-2-5.45c2-4.06,7.89,2.41,11.55,2.14l2.89-5.5Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "183.013px 306.92px"
    },
    id: "el2vktl5ldcpy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86,295.89c-.72-3.64,4.22-7.18,4-10.76-.26-4.84-6.26-1.11-8.53,5.49l-.86,5.43Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "193.169px 289.49px"
    },
    id: "elfcckww8gy2v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.13,318c.06,0,.06.08,0,.08a28.15,28.15,0,0,1-16.37-3.65c-.15-.1-.07-.39.12-.32A57.93,57.93,0,0,0,191.13,318Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.928px 316.138px"
    },
    id: "elyzx55ve662",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,311.73a.06.06,0,0,1,0,.12,26.45,26.45,0,0,1-17.6-5.1c-.18-.14-.2-.43,0-.29C178.94,308.84,187.74,311.34,193,311.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.159px 309.17px"
    },
    id: "elerzsmmsw4ya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.6,299c5,3.61,10.64,5.26,16.68,6.12.08,0,.06.12,0,.13-3.07.39-6.87-.56-9.76-1.55a16.23,16.23,0,0,1-7-4.53C176.39,299.12,176.49,299,176.6,299Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.896px 302.17px"
    },
    id: "elbl5yxp3m4u",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakingNotesAnimate);
export default __webpack_public_path__ + "static/media/taking-notes-animate.9ddbc5b49e778f320d175c61ead578e8.svg";
export { ForwardRef as ReactComponent };